import React, { useEffect, useLayoutEffect, useState } from "react";
// import { toast, ToastContainer } from "react-toastify";
import { useHistory, useLocation } from "react-router-dom";
import useLocalStorageState from "use-local-storage-state";
import axios from "axios";
import config from "./services/config.json";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import Search from "./components/search/Search";
import SideBar from "./components/SideBar/SideBar";
import TitleBox from "./components/common/TitleBox";
import BackDrop from "./components/SideBar/BackDrop";
import SBackDrop from "./components/search/SBackDrop";
import Register from "./components/register/Register";
import SimpleContext from "./components/context/SimpleContext";
import FreshSearch from "./components/search/FreshSearch/FreshSearch";
import FreshBackDrop from "./components/search/FreshSearch/FreshBackDrop";
import SecondRegister from "./components/register/SecondRegister";
import NotRegistered from "./components/register/NotRegistered";
import { Button, Modal } from "react-bootstrap";
import success from "./components/img/ic_payment_success.png";
import unsuccess from "./components/img/ic_payment_failed.png";
import LoginWithCode from "../src/components/register/LoginWithCode";
import UserCode from "../src/components/register/UserCode";
import { AES, enc } from "crypto-js";
import placeH from "./../src/components/img/placeH.jpg";
import cross from "./../src/components/img/cross.png";
import Preloader2 from "./components/common/Preloader2";
import Preloader3 from "./components/common/Preloader3";
import { browserName, browserVersion } from "react-device-detect";
const App = () => {
  const [baseUrlApiPakhsh] = useState("https://apipakhsh.ir");
  // const [baseUrlApiPakhsh] = useState("https://apikala.igzas.ir");
  // const [baseUrlApiPakhsh] = useState("https://apikala.igzas.ir");
  // const [baseUrlApiPakhsh] = useState("https://dev2ak.igzas.ir");
  // const [baseUrlApiPakhsh] = useState("https://apipakhshv3.igzas.ir");
  // const [baseUrlApiPakhsh] = useState("https://apipakhshv3.igzas.ir");
  const history = useHistory();
  const location = useLocation();
  const [clicked, setClicked] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [getsideDrawer, setsideDrawer] = useState(false);
  const [getSearchDrawer, setSearchDrawer] = useState(false);
  const [getTarhdarDrawer, setTarhdarDrawer] = useState(false);
  const [getProductDrawer, setProductDrawer] = useState(false);
  const [getFreshSearchDrawer, setFreshSearchDrawer] = useState(false);
  const [NumUnitDiscount, setNumUnitDiscount] = useState(0);
  const [hi, setHi] = useLocalStorageState("hi", []);
  const [verCode, setVerCode] = useState(0);
  const [searchtxt, setsearchtxt] = useState(" ");
  const [style, setStyle] = useState("TarhNamePlace");
  const [getcontentPage, setcontentPage] = useState("1");
  const [FestivalDataPoints, setFestivalDataPoints] = useState({});
  const [freshSearchtxt, setfreshSearchtxt] = useState(" ");
  const [row1, setrow1] = useState([]);
  const [row2, setrow2] = useState([]);
  const [row3, setrow3] = useState([]);
  const [row4, setrow4] = useState([]);
  const [row5, setrow5] = useState([]);
  const [row6, setrow6] = useState([]);
  const [row7, setrow7] = useState([]);
  const [row8, setrow8] = useState([]);
  const [Acts, setActs] = useState([]);
  const [Listt, setListt] = useState([]);
  const [Offers, setOffers] = useState([]);
  const [myinfo, setmyinfo] = useState([]);
  const [brands, setbrands] = useState([]);
  const [MainCat, setMainCat] = useState([]);
  const [myTarhs, setmyTarhs] = useState([]);
  const [category, setCategory] = useLocalStorageState("category", []);
  const [products, setProducts] = useState([]);
  const [getIsShowOne, setIsShowOne] = useState([]);
  const [allProducts, setallProducts] = useState([]);
  const [getimagenames, setimagenames] = useState([]);
  const [categorylev3, setCategorylev3] = useState([]);
  const [categorylev2, setCategorylev2] = useState([]);
  const [catNameHeader, setcatNameHeader] = useState([]);
  const [bannerProduct, setbannerProduct] = useState([]);
  const [getTarhdarImages, setTarhdarImages] = useState([]);
  const [Error, setError] = useState(false);
  const [ToastMsge, setToastMsge] = useState("");
  const [getFirstPageTotal, setFirstPageTotal] = useState([]);
  const [productNameHeader, setproductNameHeader] = useState([]);
  const [SinglePrdCategory, setSinglePrdCategory] = useState([]);
  const [ShopedProductList, setShopedProductList] = useState([]);
  const [FreshProductsList, setFreshProductsList] = useState([]);
  const [getFreshListFSearch, setFreshListFSearch] = useState([]);
  const [SinglePrdCategory2, setSinglePrdCategory2] = useState([]);
  const [getFilteredByImgTarh, setFilteredByImgTarh] = useState([]);
  const [getFreshSearchedProducts, setFreshSearchedProducts] = useState([]);
  const [getFinalFreshResponse, setFinalFreshResponse] = useState([]);
  const [getSearchedProducts, setSearchedProducts] = useLocalStorageState(
    "SearchedProducts",
    [],
  );
  const [DiscCode, setDiscCode] = useLocalStorageState("DiscCode", []);
  const [getVaranegarOrderResponse, setgetVaranegarOrderResponse] =
    useLocalStorageState("getVaranegarOrderResponse", []);
  const [getInsertOrderResponse, setgetInsertOrderResponse] =
    useLocalStorageState("getInsertOrderResponse", []);
  const [FreshInsertOrderResponse, setFreshInsertOrderResponse] = useState([]);
  const [ApiFactorResponse, setApiFactorResponse] = useLocalStorageState(
    "ApiFactorResponse",
    [],
  );
  const [KFPFactorResponse, setKFPFactorResponse] = useLocalStorageState(
    "KFPFactorResponse",
    [],
  );
  const [PreOrderFactorResponse, setPreOrderFactorResponse] =
    useLocalStorageState("PreOrderFactorResponse", []);
  const [FullDate, setFullDate] = useState("");
  const [bothId, setbothId] = useLocalStorageState("bothId", Date.now());
  const [SimplePrd, setSimplePrd] = useLocalStorageState("SimplePrd", []);
  const [IsLoggedIn, setIsLoggedIn] = useLocalStorageState("IsLoggedIn", false);
  const [latCenter, setlatCenter] = useLocalStorageState("latCenter", []);
  const [langCenter, setlangCenter] = useLocalStorageState("langCenter", []);
  const [userIdMap, setuserIdMap] = useLocalStorageState("userIdMap", []);
  const [userCodeMap, setuserCodeMap] = useLocalStorageState("userCodeMap", []);
  const [userPhoneMap, setuserPhoneMap] = useLocalStorageState(
    "userPhoneMap",
    [],
  );
  const [UserLat, setUserLat] = useLocalStorageState("UserLat", []);
  const [UserLang, setUserLang] = useLocalStorageState("UserLang", []);
  const [IsLoggedWithSms, setIsLoggedWithSms] = useLocalStorageState(
    "IsLoggedWithCode",
    false,
  );
  const [IsLoggeCode, setIsLoggeCode] = useLocalStorageState(
    "IsLoggeCode",
    false,
  );
  const [IsLoggedIn2, setIsLoggedIn2] = useLocalStorageState(
    "IsLoggedIn2",
    false,
  );
  const [NotRegisteredAtCO, setNotRegisteredAtCO] = useLocalStorageState(
    "NotRegisteredAtCO",
    false,
  );
  const [number, setNumber] = useState(0);
  const [Maximum, setMaximum] = useLocalStorageState("Maximum", 0);
  const [TarhPrdCode, setTarhPrdCode] = useLocalStorageState("TarhPrdCode", 0);
  const [ApiSetting, setApiSetting] = useLocalStorageState("ApiSetting", {});
  const [festivalData, setFestivalData] = useState({});
  const [SumTarh, setSumTarh] = useState(0);
  const [PrdCount, setPrdCount] = useState(0);
  const [TTotalPrice, setTTotalPrice] = useState(0);
  const [FreshTTotalPrice, setFreshTTotalPrice] = useState(0);
  const [StockProduct, setStockProduct] = useState([]);
  const [resAdd, setresAdd] = useState(false);
  const [getofferBanners, setofferBanners] = useLocalStorageState(
    "offerBanners",
    [],
  );
  const [FreshStockProduct, setFreshStockProduct] = useState([]);
  const [TarhNameHeader, setTarhNameHeader] = useLocalStorageState(
    "TarhNameHeader",
    [],
  );
  const [varaanegar_stock, setvaraanegar_stock] = useLocalStorageState(
    "varaanegar_stock",
    [],
  );
  const [MyList, setMyList] = useLocalStorageState("MyList", []);
  const [tarikh, setTarikh] = useLocalStorageState("tarikh", []);
  const [UseInFo, setUseInFo] = useLocalStorageState("UseInFo", {});
  const [loopArr, setloopArr] = useLocalStorageState("loopArr", []);
  const [CartItems, setCartItems] = useLocalStorageState("CartItems", []);
  const [getDiscount, setDiscount] = useLocalStorageState("Discount", []);
  const [ApiFactors, setApiFactors] = useLocalStorageState("ApiFactors", []);
  const [KFPfactors, setKFPfactors] = useLocalStorageState("KFPfactors", []);
  const [getProductsC, setProductsC] = useLocalStorageState("getProductsC", []);
  const [Freshfactors, setFreshfactors] = useLocalStorageState(
    "Freshfactors",
    [],
  );
  const [SabadResponse, setSabadResponse] = useLocalStorageState(
    "SabadResponse",
    [0],
  );
  const [FRESHCartItems, setFRESHCartItems] = useLocalStorageState(
    "FRESHCartItems",
    [],
  );
  const [getCategorylev2C, setCategorylev2C] = useLocalStorageState(
    "Categorylev2C",
    [],
  );
  const [getDiscountGroups, setDiscountGroups] = useLocalStorageState(
    "DiscountGroups",
    [],
  );
  const [getFilteredTarhydar, setFilteredTarhydar] = useLocalStorageState(
    "FilteredTarhydar",
    [],
  );
  const [getProductsC_Levtwo, setProductsC_Levtwo] = useLocalStorageState(
    "getProductsC_Levtwo",
    [],
  );
  const [FreshSabadResponse, setFreshSabadResponse] = useLocalStorageState(
    "FreshSabadResponse",
    [0],
  );
  const [tarikhTahvilKala, setTarikhTahvilKala] = useLocalStorageState(
    "tarikhTahvilKala",
    [],
  );
  const [DeliveryDateFresh, setDeliveryDateFresh] = useLocalStorageState(
    "DeliveryDateFresh",
    [],
  );
  const [searchProducts, setsearchProducts] = useLocalStorageState(
    "searchProducts",
    {},
  );
  const [basket, setBasket] = useState(false);
  const [basketloader, setbasketloader] = useState(false);
  const [mapLoader, setmapLoader] = useState(false);
  const [FirstBasket, setFirstBasket] = useLocalStorageState("FirstBasket", {});
  const [MyBasketItems, setMyBasketItems] = useState([]);
  const [showModalTime, setshowModalTime] = useState(false);
  const [UniqueUUID, setUniqueUUID] = useLocalStorageState("UniqueUUID", 0);
  const [showPre, setshowPre] = useState(false);
  const [timeMiliSecondRes, settimeMiliSecondRes] = useState([]);
  const [timeMiliSecondDef, settimeMiliSecondDef] = useLocalStorageState(
    "settimeMiliSecondDef",
    [],
  );
  const [resAddToCart, setresAddToCart] = useLocalStorageState(
    "resAddToCart",
    {},
  );
  const [Tarha, setTarha] = useLocalStorageState("Tarha", []);

  const [SearchField, setSearchField] = useLocalStorageState(
    "SearchField2",
    "",
  );
  const [showfield, setshowfield] = useState(false);
  const [MyId, setMyId] = useLocalStorageState("MyId", 0);
  const [TreeMenuSelectedId, setTreeMenuSelectedId] = useLocalStorageState(
    "TreeMenuSelectedId",
    0,
  );
  const [FilterPriceRange, setFilterPriceRange] = useState([0, 0]);
  const [SelectedBrandsList, setSelectedBrandsList] = useLocalStorageState(
    "SelectedBrandsList",
    [],
  );
  const [show, setshow] = useLocalStorageState("show", true);
  const [SearchBrandsSelection, setSearchBrandsSelection] = useState(
    "minibrandImgunselected",
  );
  const [discountStep, setdiscountStep] = useLocalStorageState(
    "discountStep",
    [],
  );
  const [deleteAllBrandsInSearch, setdeleteAllBrandsInSearch] =
    useLocalStorageState("deleteAllBrandsInSearch", false);
  const [link, setlink] = useLocalStorageState("link", []);
  const [TarhaTitle, setTarhaTitle] = useLocalStorageState("TarhaTitle", []);
  const [showCat, setshowCat] = useLocalStorageState("showCat", false);
  const [theme, setTheme] = useState("#ff7014");
  const [modalPopUp, setmodalPopUp] = useState(false);
  const [TextPopUp, setTextPopUp] = useLocalStorageState("TextPopUp", {});
  const [headerCat, setheaderCat] = useLocalStorageState("headerCat", []);
  const [showCatId, setshowCatId] = useLocalStorageState("showCatId", 0);
  const [getBrandsList, setgetBrandsList] = useLocalStorageState(
    "getBrandsList",
    [],
  );
  const [homepageBanner, sethomepageBanner] = useLocalStorageState(
    "homepageBanner",
    {},
  );
  const [showBrand, setshowBrand] = useLocalStorageState("showBrand", false);
  const [buttontitle, setButtontitle] = useLocalStorageState("buttontitle", "");
  const [List, setList] = useLocalStorageState("List", []);
  const [sort, setsort] = useLocalStorageState("sort", 2);
  const [toast, setToast] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [showToast2, setShowToast2] = useState(false);
  const [loc, setloc] = useState(false);
  const [loctest, setloctest] = useState("");
  const [changeView, setchangeView] = useState(true);
  const [brandName, setbrandName] = useLocalStorageState("brandName", "");
  const [BrandOfId, setBrandOfId] = useLocalStorageState("BrandOfId", []);
  const [BadgeOfBasket, setBadgeOfBasket] = useLocalStorageState(
    "BadgeOfBasket",
    "",
  );
  const [ToastError, setToastError] = useState(false);
  const [CatLoader, setCatLoader] = useState(false);
  const [showChat, setshowChat] = useState([]);
  const [errorText, seterrorText] = useState("");
  const [errorshow, seterrorshow] = useState(false);
  const [enterpass, setenterpass] = useState([]);
  const [codeOfUser, setcodeofUser] = useLocalStorageState("codeOfUser", 0);
  const [setPassModal, setsetPassModal] = useState(false);

  const [ConfirmPass, setConfirmPass] = useState([]);
  const [userPassword, setuserPassword] = useLocalStorageState(
    "userPassword",
    0,
  );
  const [enterpassUser, setenterpassUser] = useState([]);
  const [api, setapi] = useLocalStorageState("api", []);
  const [Kfp, setKfp] = useLocalStorageState("Kfp", []);
  const [showapi, setShowApi] = useLocalStorageState("showapi", false);
  const [showKfp, setShowKfp] = useLocalStorageState("showKfp", false);

  const [rullsText, setrullsText] = useState("");
  const [fave, setfave] = useLocalStorageState("fave", 0);
  const [bouhgt, setbouhgt] = useLocalStorageState("bouhgt", 0);
  const [AppType, setAppType] = useLocalStorageState("AppType", 0);
  const [dis, setdis] = useLocalStorageState("dis", 0);
  const [selectbutton, setselectbutton] = useState(false);
  const [validModal, setvalidModal] = useState(false);
  const [productNum, setproductNum] = useLocalStorageState("productNum", []);

  const [IsLoadingBasket, setIsLoadingBasket] = useState(true);
  const [productNumBasket, setproductNumBasket] = useLocalStorageState(
    "productNumBasket",
    {},
  );
  const [showmodalNumBasket, setshowmodalNumBasket] = useState(false);
  const [showmodalNumProduct, setshowmodalNumProduct] = useState(false);
  const [resOfSelect, setresOfSelect] = useState({});
  const [add, setadd] = useState([]);
  const [addg, setaddg] = useState([]);
  const [addRes, setaddRes] = useState({});
  const [addpre, setaddpre] = useState(false);
  const [showmodalNum, setshowmodalNum] = useState(false);
  const [justFav, setjustFav] = useState(0);
  const [unitProduct, setunitProduct] = useLocalStorageState("unitProduct", []);
  const [gerami, setgerami] = useLocalStorageState("gerami", false);
  const [, setforceUpdate] = useState(0);
  const [showBasket, setshowBasket] = useState(false);
  const [slugCount, setslugCount] = useState([]);
  const [iscorrect, setisorrect] = useState(false);
  const [notExistRes, setnotExistRes] = useLocalStorageState("notExistRes", "");
  const [phoneOfSupport, setphoneOfSupport] = useLocalStorageState(
    "phoneOfSupport",
    [],
  );
  const [detailsOfOrders, setdetailsOfOrders] = useLocalStorageState(
    "detailsOfOrders",
    [],
  );
  const [showCountIn, seshowCountIn] = useState(false);
  const [AddtoCardResponse, setAddtoCardResponse] = useLocalStorageState(
    "AddtoCardResponse",
    [],
  );
  const [brandsOfDis, setbrandsOfDis] = useState([]);
  const [BrandIdForUser, setBrandIdForUser] = useLocalStorageState(
    "BrandIdForUser",
    -1,
  );
  const [productsDetails, setproductsDetails] = useLocalStorageState(
    "productsDetails",
    [],
  );
  const [productRoight, setproductRoight] = useLocalStorageState(
    "productRoight",
    "/product",
  );
  const [searchBodyOfProduct, setsearchBodyOfProduct] = useLocalStorageState(
    "searchBodyOfProduct",
    {},
  );
  const [orderDetailApi, setorderDetailApi] = useLocalStorageState(
    "orderDetailApi",
    [],
  );
  const [orderDetailKfp, setorderDetailKfp] = useLocalStorageState(
    "orderDetailKfp",
    [],
  );
  const [orderDetailId, setorderDetailId] = useLocalStorageState(
    "orderDetailId",
    0,
  );
  const [uisetting, setuisetting] = useLocalStorageState("uisetting", {});
  const [random, setrandom] = useLocalStorageState("random", []);
  const [goBrand, setgoBrand] = useLocalStorageState("goBrand", false);
  //پریلودر ها
  const [showPrepage, setshowPrepage] = useState(false);
  const [pre, setpre] = useState(false);
  const [preButton, setpreButton] = useState(false);
  const [preCount, setpreCount] = useState(false);
  const [page, setpage] = useState(0);
  // const [reloadTriggered, setReloadTriggered] = useState(false);

  useEffect(() => {
    festivalPont();
  }, []);
  // useEffect(() => {
  //   if (!reloadTriggered) {
  //     setReloadTriggered(true);
  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 1000); // Delay the reload for 1 second (1000 milliseconds)
  //   }
  // }, [reloadTriggered]);

  // useEffect(()=>{
  //  if(localStorage.getItem("clearData")===null||localStorage.getItem("clearData")===undefined|| JSON.parse(localStorage.getItem("clearData")===false)){
  //    localStorage.clear();
  //    localStorage.setItem("clearData", JSON.stringify(true))
  //    window.location.reload();
  //  }
  // },[])

  // // **********************************************************
  //   //تابع برای حذف کش مروروگر
  // //اگر از وب سرویس 1 دریافت شود کش مرورگر کاربر پاک میشود
  // useEffect(() => {
  //   String.prototype.toEnglishDigit = function () {
  //     var find = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  //     var replace = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  //     var replaceString = this;
  //     var regex;
  //     for (var i = 0; i < find.length; i++) {
  //       regex = new RegExp(find[i], "g");
  //       replaceString = replaceString.replace(regex, replace[i]);
  //     }
  //     return replaceString;
  //   };
  //   if (UserPhone.length > 0) {
  //     let MyTime = Date.now();
  //     let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
  //     const myheaders = {
  //       "atu-token": TimeHeader,
  //     };
  //     async function FinalPost() {
  //       const url = `${baseUrlApiKala}/v2/getClearCatch`;
  //       const formData = new FormData();
  //       formData.append(
  //         "mobile",
  //         UserPhone.length === 0 ? 0 : UserPhone.toEnglishDigit()
  //       );
  //       formData.append("appType", AppType);
  //       formData.append(
  //         "addressID",
  //         Object.values(selectedAddress).length > 0
  //           ? selectedAddress.addressId
  //           : 0
  //       );
  //       const param = {
  //         method: "Post",
  //         body: formData,
  //         headers: myheaders,
  //       };

  //       const sendRequestSabt = await fetch(url, param);
  //       const responseSabt = await sendRequestSabt.json();
  //       return responseSabt;
  //     }
  //     try {
  //       FinalPost().then((data) => {
  //         if (parseInt(data.code) === 200) {
  //           if (getCatch === 1) {
  //             setupdateMessageShow(true);
  //           }
  //           setgetcatch(data.response);
  //         } else if (parseInt(data.code) === 401) {
  //           setshowModalTime(true);
  //         }
  //       });
  //     } catch (ex) {
  //       console.log(ex);
  //     }
  //   }
  // }, [window.location.href]);
  /****************************************************تابع نمایش توست **************************************************** */
  const HandelShowContentPage = (name) => {
    let contentPageValue = [...getcontentPage];
    contentPageValue = name;
    setcontentPage(contentPageValue);
    let toastContent = "";

    switch (name) {
      case "1":
        toastContent = "متاسفانه این فروشگاه برای آدرس شما سرویس نمیدهد!";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "2":
        toastContent = "کالا به سبد خرید اضافه شد.";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "3":
        toastContent = `خطای داده های سرور`;
        setToast(toastContent);
        setShowToast(true);
        break;
      case "4":
        toastContent = `خطای ارتباط با سرور`;
        setToast(toastContent);
        setShowToast(true);
        break;
      case "5":
        toastContent = "کد احراز هویت معتبر نیست!";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "6":
        toastContent = "تصویر شما با موفقیت ثبت شد";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "7":
        toastContent = "خطایی رخ داده است!";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "8":
        toastContent = "ظرفیت ارسال در این بازه به اتمام رسیده است.";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "9":
        toastContent = "خطای دریافت timeMiliSecond";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "10":
        toastContent = "مشخصات شما با موفقیت ویرایش شد";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "11":
        toastContent = "آدرس پیش فرض تغییر پیدا کرد";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "12":
        toastContent = "نوع پرداخت انتخاب شود";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "13":
        toastContent = "خطا در ثبت سفارش";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "14":
        toastContent = "شما از سهمیه خود استفاده کرده اید!";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "15":
        toastContent = "فعلا این فروشگاه در شهر شما قادر به ارائه خدمات نیست!";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "15":
        toastContent = "فعلا این فروشگاه در شهر شما قادر به ارائه خدمات نیست!";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "خطا در ارسال پیامک احراز هویت. لطفا بعد از 1 دقیقه مجدداْ تلاش کنید.":
        toastContent = name;
        setToast(toastContent);
        setShowToast(true);
        break;
      case "16":
        toastContent =
          "خطا در ارسال پیامک احراز هویت. لطفا بعد از 1 دقیقه مجدداْ تلاش کنید.";
        setToast(toastContent);
        setShowToast(true);
        break;
    }
  };

  const HandelShowContentPage2 = (name) => {
    let contentPageValue = [...getcontentPage];
    contentPageValue = name;
    setcontentPage(contentPageValue);
    let toastContent = "";

    switch (name) {
      case "1":
        toastContent = "متاسفانه این فروشگاه برای آدرس شما سرویس نمیدهد!";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "2":
        toastContent = "کالا به سبد خرید اضافه شد.";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "3":
        toastContent = `خطای داده های سرور`;
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "4":
        toastContent = `خطای ارتباط با سرور`;
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "5":
        toastContent = "کد احراز هویت معتبر نیست!";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "6":
        toastContent = "تصویر شما با موفقیت ثبت شد";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "7":
        toastContent = "خطایی رخ داده است!";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "8":
        toastContent = "ظرفیت ارسال در این بازه به اتمام رسیده است.";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "9":
        toastContent = "خطای دریافت timeMiliSecond";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "10":
        toastContent = "مشخصات شما با موفقیت ویرایش شد";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "11":
        toastContent = "آدرس پیش فرض تغییر پیدا کرد";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "12":
        toastContent = "نوع پرداخت انتخاب شود";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "13":
        toastContent = "خطا در ثبت سفارش";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "14":
        toastContent = "شما از سهمیه خود استفاده کرده اید!";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "15":
        toastContent = "فعلا این فروشگاه در شهر شما قادر به ارائه خدمات نیست!";
        setToast(toastContent);
        setShowToast2(true);
        break;
      case "15":
        toastContent = "فعلا این فروشگاه در شهر شما قادر به ارائه خدمات نیست!";
        setToast(toastContent);
        setShowToast(true);
        break;
      case "خطا در ارسال پیامک احراز هویت. لطفا بعد از 1 دقیقه مجدداْ تلاش کنید.":
        toastContent = name;
        setToast(toastContent);
        setShowToast(true);
        break;
    }
  };

  //برای هندل کردن ارور عکس ها
  const addDefaultSrc = (ev) => {
    ev.target.src = "/images/placeholder.jpg";
  };

  const Handelerror = (name) => {
    // if(ToastError===false){
    setToastError(false);
    // }else if (ToastError===true){
    //   setToastError(false);
    // }
    setToast(name);
  };
  useEffect(() => {
    if (ToastError === false) {
      setToastError(true);
    } else if (ToastError === true) {
      setTimeout(() => {
        setToast([]);
      }, 900);
    }
  }, [ToastError]);

  //تابع بستن مودال توستیفای
  const handleClose = () => {
    setShowToast(false);
  };
  //2تابع بستن مودال توستیفای
  const handleClose2 = () => {
    setShowToast2(false);
  };

  // let theme = "#ff7014";

  /****************************************************تابع انکریپت کردن کد دستگاه**************************************************** */
  const Encriptor = (EncriptText) => {
    // اصلی
    let data1 = "31FA1C22E471FD806E68E3E199DA466D";
    var data2 = "CAE875CD2B2D0F3F";

    // igzas
    // let data1 = "E7F254E2EF0C75AD89848D14DC445B49";
    // var data2 = "619CC4E6D73B6513";

    const crypto = require("crypto-js");
    const data = EncriptText.toString();
    const password = data1;
    const key = crypto.enc.Utf8.parse(password);
    const iv = crypto.enc.Utf8.parse(data2);
    const encryptedData = AES.encrypt(data, key, {
      // mode: enc.Mode.CBC,
      // padding: enc.Padding.PKCS7,
      blockSize: 256 / 8,
      iv: iv,
    }).toString();

    return encryptedData;
  };

  useEffect(() => {
    let myTime = Date.now();
    axios
      .get(`${baseUrlApiPakhsh}/api/timeMiliSecond`)
      .then((response) => {
        if (parseInt(response.data.code) === 200) {
          settimeMiliSecondDef(response.data.response - myTime);
        } else {
          console.log("1مشکلی در اتصال با سرور بوجود امده است");
        }
      })
      .catch((er) => {
        console.log(er);
        console.log("مشکلی در اتصال با سرور بوجود امده است");
      });
  }, []);

  //تابع برای فراخانی وب سرویس product
  //با استفاده از url
  useEffect(() => {
    let url = window.location.href.split("/");
    let productRef = url[5];

    if (url[4] === "product") {
      productDetails(productRef);
    }
  }, [window.location.href]);

  const drawerToggleClickHandler = () => {
    setsideDrawer(!getsideDrawer);
  };

  const backdropClickHandler = () => {
    setsideDrawer(!getsideDrawer);
  };

  const handleOpenSearch = () => {
    setsideDrawer(!getsideDrawer);
  };

  const handleCloseSidebar = (event) => {
    setsideDrawer(!getsideDrawer);
  };
  const handleCloseSearch = (event) => {
    setSearchDrawer(!getSearchDrawer);
  };
  const handleCloseFreshSearch = (event) => {
    setFreshSearchDrawer(!getFreshSearchDrawer);
  };
  const handleTarhdarDrawer = () => {
    setTarhdarDrawer(!getTarhdarDrawer);
  };
  const handleProductDrawer = () => {
    setProductDrawer(!getProductDrawer);
  };

  /***************************************brands product***************************************** */

  const handleFilterProducts = (id) => {
    setshowCatId(id);
    let productsC = [...products];
    const filteredProducts = productsC.filter(
      (product) => product.brandID == id.brandid,
    );
    setProductsC(filteredProducts);
    history.push("/Products");
  };

  /***************************************category level 2***************************************** */

  const handleShowCategoryLevelTwoProducts = (catL3, gname) => {
    let productsC_Levtwo = [...products];
    const filteredProducts_Levtwo = productsC_Levtwo.filter(
      (product) => product.LastLevID === catL3,
    );
    setProductsC_Levtwo(filteredProducts_Levtwo);
    setproductNameHeader(gname);
    history.push("/ProductsLev2");
  };

  const handleShowCategoryLevelThreeProducts = (catID) => {
    let productsC_Levtwo = [...products];
    const filteredProducts_Levtwo = productsC_Levtwo.filter(
      (product) => product.LastLevID === catID,
    );
    setProductsC_Levtwo(filteredProducts_Levtwo);
    history.push("/ProductsLev2");
  };

  /***************************************show each category's products***************************************** */

  const handleFilterCategory = (id, GroupName) => {
    setsearchProducts({});
    setgoBrand(false);
    setSelectedBrandsList([]);
    setsearchBodyOfProduct({});
    setshowCatId(id);
    setheaderCat(GroupName);
    categories(id, []);
    search(0, "", 0, id, [], sort, 0, 0, 0, searchBodyOfProduct);
    history.push("/CategoriesProducts");
  };

  const handleFilterByCatName = (gname) => {
    let allProducts = [...categorylev2];
    const filteredProducts = allProducts.filter((product) =>
      product.name.includes(gname),
    );
    setallProducts(filteredProducts);
  };

  const handleSearchProducts = (search) => {
    let searchedProducts = [...products];
    const SearchedProducts = searchedProducts.filter((product) =>
      product.name.includes(search),
    );
    setSearchedProducts(SearchedProducts);
    setSearchDrawer(false);
    history.push("/ُSearchResults");
  };

  const handleShowShopedProducts = (slug) => {
    let shpedProducts = [...products];
    const ShopedProducts = shpedProducts.filter(
      (product) => product.slug === slug,
    );
    setShopedProductList(ShopedProducts);
    history.push("/ُShopResults");
  };

  const click = (event) => {
    let shpedProducts = [...products];
    const num2x = ShopedProductList.map((n) =>
      shpedProducts.filter((product) => product.slug === n),
    );
    setListt(num2x);
    history.push("/Shops");
  };

  /***************************************Push And Replace History***************************************** */
  const handleHistoryPush = (path) => {
    history.push(path);
  };

  const handleHistoryreplace = (path) => {
    history.replace(path);
  };

  /***************************************Actions First Page***************************************** */
  const homepageOnClickBanners = (action) => {
    let actionValue = action;
    // setactionValue(actionValue);
    let actionContent = "";

    switch (actionValue) {
      case 1:
        actionContent = "/Categories";
        break;

      case 3:
        actionContent = "/Brands";
        break;
      case 4:
        actionContent = "/tarhha";
        break;
      case 5:
        actionContent = "/TarikhTahvil";
        break;

      case 7:
        actionContent = "/mylist";
        break;
      case 8:
        actionContent = "/CustomerActs";
        break;

      default:
        actionContent = "/Freshs";
    }

    handleHistoryPush(`${actionContent}`);
  };

  /***************************************Filter Tarhs***************************************** */
  const handlefilterTarhProducts = (prdcode) => {
    // let all = [...products];
    // const lengthh = prdcode.length;
    // const filt = [];
    // {
    //   for (var i = 0; i <= lengthh - 1; i++) {
    //     filt[i] = all.filter((product) => product.slug === prdcode[i]);
    //   }
    // }
    // setloopArr(filt);
  };

  /***************************************Filter Tarhs***************************************** */

  const handleFilterTarhDar = (discountid, prdcode, title) => {
    let discount = [...getDiscount];
    setTarhPrdCode(prdcode);
    handlefilterTarhProducts(prdcode);
    const filteredTarhdarProducts = discount.filter(
      (product) => product.DiscountGroup === discountid,
    );
    setFilteredTarhydar(filteredTarhdarProducts);
    handleHistoryPush("/tarhdarproducts");
    setTarhNameHeader(title);
  };

  const handleShowFilteredTarhs = (slugname) => {
    let filteredTarh = [...getDiscountGroups];
    const filteredTarhdars = filteredTarh.filter((pr) => pr.Img === slugname);
    setFilteredByImgTarh(filteredTarhdars);
    setClicked(true);
  };

  /************************************************************************* */

  const handleShowTrhsFilteredBySlugName = (slug) => {
    let disGroup = [...getDiscountGroups];
    const filteredDiscount = disGroup.filter((dis) => {
      const prds = [...dis.prdcode];
      if (prds.includes(slug)) {
        setDiscCode(dis.DiscountGroup);
      }
    });
  };

  /***************************************Fresh Search***************************************** */
  const handleFilteredFreshSearched = (searchname) => {
    let filteredFresh = [...products];
    let FreshList = [...FreshProductsList];
    const filteredFreshs = filteredFresh.filter(
      (pr) => pr.name.includes(searchname) && pr.IsFresh == 1,
    );
    const filteredFreshList = FreshList.filter((pr) =>
      pr.lev2Name.includes(searchname),
    );
    setFreshSearchedProducts(filteredFreshs);
    setFreshListFSearch(filteredFreshList);
    setFreshSearchDrawer(false);
    handleHistoryPush("/freshsearch");
  };

  /***************************************Show Single Product***************************************** */
  const handleShowSimpleProduct = (slug, stock, numSale) => {
    handleShowTrhsFilteredBySlugName(slug);
    if (stock === 0 || stock === numSale) {
      HandelShowContentPage("11");
    } else {
      let Simple = [...products];
      const SimplePrdd = Simple.filter((pr) => pr.slug === slug);

      setSimplePrd(SimplePrdd);
      handleHistoryPush("/simpleproduct");
    }
  };

  /***************************************Exit Button***************************************** */

  const clearLocalStorage = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setModalShow(!modalShow);
    window.location.reload();
  };

  /***************************************Exit Button***************************************** */

  /***************************************Back Drops***************************************** */
  let backDrop;
  if (getsideDrawer) {
    backDrop = <BackDrop />;
  }
  let backDrop2;
  if (getSearchDrawer) {
    backDrop2 = <SBackDrop />;
  }
  let backDrop3;
  if (getFreshSearchDrawer) {
    backDrop3 = <FreshBackDrop />;
  }
  /***************************************Back Drops***************************************** */

  /**************************************Sabad Kharid***************************************** */

  const handleDeleteItemFromSabad = (slug) => {
    const Item = CartItems.filter((item) => item.slug !== slug);
    setCartItems(Item);
  };

  const badgeNum = (slug) => {
    const ProductExist = CartItems.filter((item) => item.slug === slug);
    if (ProductExist !== undefined) {
      ProductExist.map((pr) => setPrdCount(pr.ProCount));
    } else {
      setPrdCount(0);
    }
  };

  const handleAddProduct = (props) => {
    const ProductExist = CartItems.find((item) => item.slug === props.slug);
    if (ProductExist !== undefined) {
      setCartItems(
        CartItems.map((item) =>
          item.slug === props.slug
            ? { ...ProductExist, ProCount: props.num.num + 1 }
            : item,
        ),
      );
    } else {
      setCartItems([...CartItems, { ...props, ProCount: props.num.num + 1 }]);
    }
  };

  const handleRemoveProduct = (props) => {
    const ProductExistt = CartItems.find((item) => item.slug === props.slug);
    setCartItems(
      CartItems.map((item) =>
        item.slug === props.slug
          ? { ...ProductExistt, ProCount: props.num.num - 1 }
          : item,
      ),
    );
  };

  /**************************************FRESH Sabad Kharid***************************************** */

  const handleDeleteFRESHItemFromSabad = (slug) => {
    const FreshItem = FRESHCartItems.filter((item) => item.slug !== slug);
    setFRESHCartItems(FreshItem);
  };

  const FRESHbadgeNum = (slug) => {
    const FRESHProductExist = FRESHCartItems.filter(
      (item) => item.slug === slug,
    );
    if (FRESHProductExist !== undefined) {
      FRESHProductExist.map((pr) => setPrdCount(pr.ProCount));
    } else {
      setPrdCount(0);
    }
  };

  const handleAddFRESHProduct = (props) => {
    const FRESHProductExist = FRESHCartItems.find(
      (item) => item.slug === props.slug,
    );
    if (FRESHProductExist !== undefined) {
      setFRESHCartItems(
        FRESHCartItems.map((item) =>
          item.slug === props.slug
            ? { ...FRESHProductExist, ProCount: props.num.num + 1 }
            : item,
        ),
      );
    } else {
      setFRESHCartItems([
        ...FRESHCartItems,
        { ...props, ProCount: props.num.num + props.min },
      ]);
    }
  };

  const handleRemoveFRESHProduct = (props) => {
    const FRESHProductExistt = FRESHCartItems.find(
      (item) => item.slug === props.slug,
    );
    setFRESHCartItems(
      FRESHCartItems.map((item) =>
        item.slug === props.slug
          ? { ...FRESHProductExistt, ProCount: props.num.num - 1 }
          : item,
      ),
    );
  };

  /***************************************FRESH Sabad Kharid***************************************** */

  const AddBasketFromSimpleProductSlider = (props) => {
    const CartExist = CartItems.find((item) => item.slug === props.slug);

    if (CartExist !== undefined) {
      setCartItems(
        CartItems.map((item) =>
          item.slug === props.slug ? { ...CartExist, ProCount: number } : item,
        ),
      );
    } else {
      setCartItems([...CartItems, { ...props, ProCount: number }]);
    }
  };
  /****************************************************************Varanegar_Discount*************************************************************** */

  const Varanegar_Discountfresh = () => {
    let FreshArrayOfBasket = [];
    FRESHCartItems.map((i) =>
      FreshArrayOfBasket.push({
        GoodsRef: i.goodsRef,
        TotalQty: i.ProCount * i.numSale,
      }),
    );

    const propsForDescountFresh = {
      BuyTypeRef: "0",
      CustRef: UseInFo.backofficeID,
      DealerRef: "238",
      DisType: "2",
      OrderDate: tarikh,
      OrderTypeRef: "21",
      PaymentUsanceRef: 39,
      PreSaleEvcDetails: FreshArrayOfBasket,
      SaleOfficeRef: "1",
    };
  };
  const Varanegar_Discount = () => {
    let arrayOfBasket = [];

    CartItems.map((i) =>
      arrayOfBasket.push({
        GoodsRef: i.goodsRef,
        TotalQty: i.ProCount * i.numSale,
      }),
    );

    const propsForDescount = {
      BuyTypeRef: "0",
      CustRef: UseInFo.backofficeID,
      DealerRef: "174",
      DisType: "2",
      OrderDate: tarikh,
      OrderTypeRef: "19",
      PaymentUsanceRef: 39,
      PreSaleEvcDetails: arrayOfBasket,
      SaleOfficeRef: "1",
    };
  };

  //وب سرویس طرح ها
  const tarh = () => {
    setTarha([]);
    setpreButton(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .post(
        `${baseUrlApiPakhsh}${config.discounts}`,
        {
          customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
          appTypeId: AppType,
          discountIds: [],
          appVersion: browserName,
          AndroidVersion: browserVersion,
          deviceId: UniqueUUID,
        },
        { headers: myheaders },
      )
      .then((response) => {
        setpreButton(false);
        if (response.data.popUp !== null) {
          if (
            response.data.popUp.text === "" &&
            response.data.popUp.imageLink === ""
          ) {
            window.open(response.data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(response.data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        if (response.data.code === 200) {
          let ss = [];
          ss.push(response.data.response);
          setTarha(ss[0]);
        } else if (response.data.code === 401) {
          setshowModalTime(true);
        } else {
          Handelerror(response.data.message);
        }
      })
      .catch((er) => {
        console.log(er);
      });
  };

  //وب سرویس برای فراخانی محصولات صفحه سرچ
  const search = (
    page,
    field,
    discountsId,
    catId,
    brands,
    sortt,
    favjust,
    boughjust,
    disjust,
    searchBody,
  ) => {
    if (field !== "") {
      setshowCat(true);
    } else {
      setshowCat(false);
    }
    setshowPre(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function FinalPost() {
      const url = `${baseUrlApiPakhsh}/api/products?page=${page}&perPage=10`;

      //برای این که متوجه بشیم کاربر از صفحه بنر ها آمده یا نه
      let data = {};
      if (searchBody !== null) {
        if (
          searchBody === undefined ||
          Object.values(searchBody).length === 0
        ) {
          data = {
            customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
            appTypeId: AppType,
            brandIds: brands,
            categoryId: catId,
            cityId: 205,
            priceAs: 0,
            priceTa: 0,
            searchField: field,
            sortOrder: sortt,
            stock: false,
            productIds: [],
            discountId: discountsId,
            justMyActivity: 0,
            justFavorite: favjust,
            justBought: boughjust,
            justDiscounted: disjust,
            justMyActivity: 0,
            bannerRef: 0,
            appVersion: browserName,
            AndroidVersion: browserVersion,
            deviceId: UniqueUUID,
          };
        } else {
          data = searchBody;
        }
      }

      const param = {
        method: "Post",
        body: JSON.stringify(data),
        headers: myheaders,
      };
      const sendRequestSabt = await fetch(url, param);
      const responseSabt = await sendRequestSabt.json();
      return responseSabt;
    }
    try {
      FinalPost().then((r) => {
        if (r.popUp !== null) {
          if (r.popUp.text === "" && r.popUp.imageLink === "") {
            window.open(r.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(r.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        if (r.code === 200) {
          if (page > 0) {
            r.response.productLists.map((i) =>
              searchProducts.productLists.push(i),
            );
            setresAddToCart(r.response.numberOfRowBasket);
          } else {
            setsearchProducts(r.response);
            setresAddToCart(r.response.numberOfRowBasket);
          }
          // offerBoundaryAnimate
          if (searchProducts !== null) {
            if (
              searchProducts !== null &&
              Object.values(searchProducts).length > 0
            ) {
              if (searchProducts.productLists.length > 0) {
                searchProducts.productLists.forEach((object) => {
                  object.offerBoundaryAnimate = false;
                });
              }
            }
          }
          if (r.response.discountBoundaryProduct.length > 0) {
            if (Object.values(searchProducts).length > 0) {
              for (let i = 0; i < searchProducts.productLists.length; i += 1) {
                if (
                  r.response.discountBoundaryProduct.includes(
                    searchProducts.productLists[i],
                  )
                ) {
                  searchProducts.productLists[i].offerBoundaryAnimate = true;
                }
              }
            }
          }
          setshowPre(false);
        } else {
          Handelerror(r.message);
          setshowPre(false);
        }
        // .................................................
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  /*************************************************تابع برای لود تمام کالاهای سبد خرید ها و همچنین لود تاریخ و زمان های ارسالا ***************************************************** */

  const loadBasket = () => {
    setshowPre(true);
    setbasketloader(true);
    setBasket(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .post(
        `${baseUrlApiPakhsh}${config.basket}`,
        {
          customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
          basketType: 1,
          appTypeId: AppType,
          deviceId: UniqueUUID,
          appVersion: browserName,
          AndroidVersion: browserVersion,
        },
        { headers: myheaders },
      )
      .then((response) => {
        if (response.data.popUp !== null) {
          if (
            response.data.popUp.text === "" &&
            response.data.popUp.imageLink === ""
          ) {
            window.open(response.data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(response.data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        if (parseInt(response.data.code, 10) === 200) {
          countRowBaskett();
          setbasketloader(false);
          setBasket(false);
          setFirstBasket(response.data.response);
          if (FirstBasket.length > 0) {
            let arr = [];
            response.data.response.basketRows.map((i) =>
              arr.push({ basketId: i.id }),
            );
            setMyBasketItems(arr);
          }
          setshowPre(false);
        } else if (parseInt(response.data.code, 10) === 401) {
          setshowModalTime(true);
        }
      })
      .catch((er) => {
        console.log(er);
      });
  };

  //تابع برای گرفتن deviceid
  var idddd;
  useEffect(() => {
    if (UniqueUUID === 0) {
      var uuid = require("uuid");
      idddd = uuid.v4();
      setUniqueUUID(idddd);
    }
  }, []);

  // برای انتقال کاربر به صفحه ها و کامپوننت هایی که آدرس آنها تحت عنوان path به این تابع داده میشوند.
  const handleClickOnMyApiItems = (path) => {
    history.push(path);
  };

  /*************************************************تابع برای لود سبد خرید بعدی  ***************************************************** */

  const loadBasket2 = (basket) => {
    //     setbasketloader(true)
    //     async function FinalPost(){
    //         let MyTime = Date.now();
    //         let TimeHeader = Encriptor(MyTime+timeMiliSecondDef)
    //         const myheaders = {
    //             "atu-token": TimeHeader
    //         }
    //         const url = `${context.baseUrlApiPakhsh}${config.basket}`
    //         const formData = new FormData();
    //         formData.append('appType' , AppType);
    //         formData.append('mobile' , phone);
    //         formData.append('basketType' , basket);
    //         formData.append('addressID' ,MyDefaultAddress === undefined? 0 : MyDefaultAddress.addressId )
    //         const param = {
    //         method : 'Post',
    //         body : formData,
    //         headers : myheaders
    //         }
    //         const sendRequestSabt = await fetch(url , param)
    //         const responseSabt = await sendRequestSabt.json()
    //         return responseSabt
    //     }try{
    //         FinalPost()
    //         .then((data)=>{
    //             if (parseInt(data.code) === 200) {
    //             setFirstBasket(data.response)
    //             setshowPre(false)
    //             setbasketloader(false)}
    //             else if (parseInt(data.code) === 401){
    //           setshowModalTime(true)
    //            }
    //         })
    //     }catch(ex) {
    //         console.log(ex);
    //     }
    // // }
  };

  /*************************************************تابع برای افزودن کالا به سبد خرید***************************************************** */

  const handleAddToCard = (
    step,
    price,
    productRef,
    basketSelection,
    unitName,
    showPreloader,
  ) => {
    setpre(true);
    const finded = searchProducts.productLists.find(
      (i) => i.productRef === productRef,
    );
    const findedIndex = searchProducts.productLists.indexOf(finded);
    const NewSearchProduct = [...[searchProducts]];
    NewSearchProduct[0].productLists[findedIndex].showPreloader = true;
    setsearchProducts(NewSearchProduct[0]);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .post(
        `${baseUrlApiPakhsh}${config.addToCart}`,
        {
          appTypeId: AppType,
          customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
          isSet: false,
          price: price,
          productId: productRef,
          selection: basketSelection,
          appVersion: browserName,
          AndroidVersion: browserVersion,
          deviceId: UniqueUUID,
        },
        { headers: myheaders },
      )
      .then((response) => {
        if (parseInt(response.data.code, 10) === 200) {
          countRowBaskett();
          setresAdd(!resAdd);
          basketSelection = 0;
          if (response.data.popUp !== null) {
            if (
              response.data.popUp.text === "" &&
              response.data.popUp.imageLink === ""
            ) {
              window.open(response.data.popUp.link, "noopener,noreferrer");
            } else {
              setmodalPopUp(true);
              setTextPopUp(response.data.popUp);
            }
          } else {
            setmodalPopUp(false);
          }
          basketSelection = 0;
          setBadgeOfBasket(response.data.response.countInBasket);
          setresAddToCart(response.data.response);
          setpre(false);
          const finded = searchProducts.productLists.find(
            (i) => i.productRef === productRef,
          );
          const findedIndex = searchProducts.productLists.indexOf(finded);
          const NewSearchProduct = [...[searchProducts]];
          NewSearchProduct[0].productLists[findedIndex].showPreloader = false;
          NewSearchProduct[0].productLists[findedIndex].unitName =
            response.data.response.unitName;
          NewSearchProduct[0].productLists[findedIndex].basketSelection =
            response.data.response.selection;
          setsearchProducts(NewSearchProduct[0]);

          // offerBoundaryAnimate
          searchProducts.productLists.forEach((object) => {
            object.offerBoundaryAnimate = false;
          });

          if (response.data.response.discountBoundaryProduct.length > 0) {
            for (let i = 0; i < searchProducts.productLists.length; i += 1) {
              if (
                response.data.response.discountBoundaryProduct.includes(
                  searchProducts.productLists[i],
                )
              ) {
                searchProducts.productLists[i].offerBoundaryAnimate = true;
              }
            }
          }
          // .................................................
        } else if (parseInt(response.data.code, 10) === 400) {
          setresAdd(!resAdd);
          basketSelection = 0;
          Handelerror(response.data.message);
        } else if (parseInt(response.data.code, 10) === 401) {
          setresAdd(!resAdd);
          setshowModalTime(true);
          basketSelection = 0;
        }
      })
      .catch((er) => {
        setresAdd(!resAdd);
        basketSelection = 0;
        console.log(er);
      });
  };

  const handleAddToCardD = (
    step,
    price,
    productRef,
    basketSelection,
    unitName,
    showPreloader,
  ) => {
    setpre(true);
    const finded = searchProducts.productLists.find(
      (i) => i.productRef === productRef,
    );
    const findedIndex = searchProducts.productLists.indexOf(finded);
    const NewSearchProduct = [...[searchProducts]];
    NewSearchProduct[0].productLists[findedIndex].showPreloader = true;
    setsearchProducts(NewSearchProduct[0]);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .post(
        `${baseUrlApiPakhsh}${config.addToCart}`,
        {
          appTypeId: AppType,
          customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
          isSet: false,
          price: price,
          productId: productRef,
          selection: basketSelection,
          appVersion: browserName,
          AndroidVersion: browserVersion,
          deviceId: UniqueUUID,
        },
        { headers: myheaders },
      )
      .then((response) => {
        if (response.data.popUp !== null) {
          if (
            response.data.popUp.text === "" &&
            response.data.popUp.imageLink === ""
          ) {
            window.open(response.data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(response.data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        if (parseInt(response.data.code, 10) === 200) {
          countRowBaskett();
          setresAdd(!resAdd);
          tarh();
          setBadgeOfBasket(response.data.response.countInBasket);
          setresAddToCart(response.data.response);
          setpre(false);
          const finded = searchProducts.productLists.find(
            (i) => i.productRef === productRef,
          );
          const findedIndex = searchProducts.productLists.indexOf(finded);
          const NewSearchProduct = [...[searchProducts]];
          NewSearchProduct[0].productLists[findedIndex].showPreloader = false;
          NewSearchProduct[0].productLists[findedIndex].unitName =
            response.data.response.unitName;
          NewSearchProduct[0].productLists[findedIndex].basketSelection =
            response.data.response.selection;
          setsearchProducts(NewSearchProduct[0]);

          // offerBoundaryAnimate
          searchProducts.productLists.forEach((object) => {
            object.offerBoundaryAnimate = false;
          });

          if (response.data.response.discountBoundaryProduct.length > 0) {
            for (let i = 0; i < searchProducts.productLists.length; i += 1) {
              if (
                response.data.response.discountBoundaryProduct.includes(
                  searchProducts.productLists[i],
                )
              ) {
                searchProducts.productLists[i].offerBoundaryAnimate = true;
              }
            }
          }
          // .................................................
        } else if (parseInt(response.data.code, 10) === 400) {
          setresAdd(!resAdd);
          basketSelection = 0;
          Handelerror(response.data.message);
        } else if (parseInt(response.data.code, 10) === 401) {
          setresAdd(!resAdd);
          setshowModalTime(true);
        }
      })
      .catch((er) => {
        setresAdd(!resAdd);
        console.log(er);
      });
  };

  // ...............................................................................................

  //وب سرویس سنمایش دسته بندی ها
  const categories = (id, BrandId) => {
    setCatLoader(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.categoryList}`;
      const formData = new FormData();
      formData.append("categoryId", id);
      formData.append("appTypeId", AppType);
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
      );
      formData.append("brandId", BrandId);
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };

      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }

    try {
      getData().then((data) => {
        if (data.popUp !== null && data.popUp !== undefined) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        setCatLoader(false);
        setCategory(data.response);
      });
    } catch (ex) {
      console.log(ex);
      setCatLoader(false);
    }
  };

  //وب سرویس امتیازات
  const festivalPont = () => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.customerFestivalPoint}`;
      const formData = new FormData();
      formData.append("appTypeId", AppType);
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
        // 935
      );
      formData.append("deviceId", UniqueUUID);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };

      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }

    try {
      getData().then((data) => {
        if (data.popUp !== null && data.popUp !== undefined) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        if (parseInt(data.code) === 200) {
          setFestivalData(data.response);
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  //وب سرویس امتیازات
  const callPoints = () => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.customerFestivalPointDetail}`;
      const formData = new FormData();
      formData.append("appTypeId", AppType);
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
        // 935
      );
      formData.append("deviceId", UniqueUUID);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };

      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }

    try {
      getData().then((data) => {
        if (data.popUp !== null && data.popUp !== undefined) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        if (parseInt(data.code) === 200) {
          setFestivalDataPoints(data.response);
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  // وب سرویس برند ها
  const getBrands = () => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.brandList}`;
      const formData = new FormData();
      formData.append("appTypeId", AppType);
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
      );
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }

    try {
      getData().then((data) => {
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        setgetBrandsList(data.response);
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  //وب سرویس homepage
  const gethomepage = () => {
    setshowPrepage(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.homePage}`;
      // const url = `https://apikala.igzas.ir/api/homePageNew2`;
      const formData = new FormData();
      formData.append("appTypeId", AppType);
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
      );
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }

    try {
      getData().then((data) => {
        setshowPrepage(false);
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        sethomepageBanner(data.response);
      });
    } catch (ex) {
      console.log(ex);
      Handelerror("مشکلی در اتصال با سرور به وجود آمده است !");
    }
  };
  //وب سرویس sortOrderList
  const sortOrder = () => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.sortOrderList}`;
      const formData = new FormData();
      formData.append("appTypeId", AppType);
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
      );
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }

    try {
      getData().then((data) => {
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        setList(data.response);
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  //بستن موال پاپ اپ
  const closeModalPop = () => {
    if (TextPopUp.link !== "") {
      setmodalPopUp(false);
      window.open(TextPopUp.link, "noopener,noreferrer");
    } else {
      setmodalPopUp(false);
    }
  };

  //وب سرویس countRowBasket
  const countRowBaskett = () => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .post(
        `${baseUrlApiPakhsh}${config.numberOfRowBasket}`,
        {
          customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
          basketType: 1,
          appTypeId: AppType,
          appVersion: browserName,
          AndroidVersion: browserVersion,
          deviceId: UniqueUUID,
        },
        { headers: myheaders },
      )
      .then((response) => {
        // if (response.popUp !== null) {
        //   if (response.popUp.text === "" && response.popUp.imageLink === "") {
        //     window.open(response.popUp.link, "noopener,noreferrer");
        //   } else {
        //     setmodalPopUp(true)
        //     setTextPopUp(response.popUp);
        //   }
        // } else {
        //   setmodalPopUp(false);
        // }
        if (response.data.code === 200) {
          setBadgeOfBasket(response.data.response.numberOfRowBasket);
        } else if (response.data.code === 401) {
          setshowModalTime(true);
        }
      })
      .catch((er) => {
        console.log(er);
      });
  };

  // setTimeout(() => {
  //   setToastError(false);
  // }, 3000);

  //وب سرویس customerCheck
  const checkcustomer = (e) => {
    e.preventDefault();
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    setpreButton(true);
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.customerCheck}`;
      const formData = new FormData();
      formData.append("appTypeId", AppType);
      formData.append("mobile", hi);
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
      );
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        setpreButton(false);
        setUseInFo(data.response);
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        if (data.code === 404) {
          setpreButton(false);
          seterrorshow(true);
          seterrorText(data.message);
        } else if (data.code === 200) {
          setpreButton(false);
          setUseInFo(data.response);
          seterrorText(data.message);
          history.push("/userCode");
          sendCode(data.response.customerId);
          // if (UseInFo.hasPassword === false) {
          //   setpreButton(false);
          //   history.push("/userCode");
          //   sendCode();
          //   setUseInFo(data.response);
          // } else if (UseInFo.hasPassword === true) {
          //   setpreButton(false);
          //   history.push("/loginWithCode");
          // }
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  //وب سرویس ارسال پیامک احراز هویت موقع ورود کاربر
  const sendCode = (id) => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.sendVerificationCode}`;
      const formData = new FormData();
      formData.append("customerId", id);
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      formData.append("appTypeId", AppType);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
      });
    } catch (ex) {}
  };

  //وب سرویس چک کردن کد
  const loginUser = (e) => {
    setpreButton(true);
    e.preventDefault();
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.checkVerificationCode}`;
      const formData = new FormData();
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
      );
      formData.append("smsCode", codeOfUser);
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      formData.append("appTypeId", AppType);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        setpreButton(false);

        if (data.code === 200) {
          Handelerror(data.message);
          setpreButton(true);
          setIsLoggedIn(true);
          if (UseInFo.hasPassword === true) {
            history.push("/");
          } else if (UseInFo.hasPassword === false) {
            setsetPassModal(true);
            setpreButton(false);
          }
        } else if (data.code === 400) {
          Handelerror(data.message);
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };
  const loginUser2 = () => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.sendVerificationCode}`;
      const formData = new FormData();
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
      );
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      formData.append("appTypeId", AppType);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  //وب سرویس modifyPassword
  const modify = () => {
    // let MyTime = Date.now();
    // let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    // const myheaders = {
    //   "atu-token": TimeHeader,
    // };
    // setpreButton(true);
    // async function getData() {
    //   const url = `${baseUrlApiPakhsh}${config.modifyPassword}`;
    //   const formData = new FormData();
    //   formData.append(
    //     "customerId",
    //     Object.values(UseInFo).length > 0 && UseInFo.customerId
    //   );
    //   formData.append("newPassword", Pass);
    //   formData.append("oldPassword", "");
    //   formData.append("appVersion", browserName);
    //   formData.append("AndroidVersion", browserVersion);
    //   formData.append("deviceId", UniqueUUID);
    //   formData.append("appTypeId", AppType);
    //   const param = {
    //     method: "post",
    //     body: formData,
    //     headers: myheaders,
    //   };
    //   const sendRequest = await fetch(url, param);
    //   const response = await sendRequest.json();
    //   return response;
    // }
    // try {
    //   getData().then((data) => {
    //     if (data.popUp !== null) {
    //       if (data.popUp.text === "" && data.popUp.imageLink === "") {
    //         window.open(data.popUp.link, "noopener,noreferrer");
    //       } else {
    //         setmodalPopUp(true);
    //         setTextPopUp(data.popUp);
    //       }
    //     } else {
    //       setmodalPopUp(false);
    //     }
    //     setpreButton(false);
    //     if (data.code === 200) {
    //       history.push("/");
    //       setIsLoggedIn(true);
    //     } else if (data.code === 400) {
    //       Handelerror(data.message);
    //     }
    //   });
    // } catch (ex) {
    //   console.log(ex);
    // }
  };

  // وب سرویس لیست سفارشات کیمیافرد
  const KfPorder = () => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    setpreButton(true);
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.kfpOrders}`;
      const formData = new FormData();
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
      );
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      formData.append("appTypeId", AppType);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        setpreButton(false);
        if (data.code === 200) {
          setKfp(data.response);
        } else if (data.code === 400) {
          Handelerror(data.message);
        } else if (data.code === 500) {
          Handelerror(data.message);
        }
      });
    } catch (ex) {
      console.log(ex);
      HandelShowContentPage("3");
    }
  };

  // وب سرویس لیست سفارشات اپی پخش مشتری
  const CustomerOrder = () => {
    setpreButton(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    setpreButton(true);
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.apipakhshOrders}`;
      const formData = new FormData();
      // formData.append("customerId", Object.values(UseInFo).length > 0 && UseInFo.customerId);
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
      );
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      formData.append("appTypeId", AppType);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        setpreButton(false);
        if (data.code === 200) {
          setapi(data.response);
          Handelerror(data.message);
          if (data.popUp !== null) {
            if (data.popUp.text === "" && data.popUp.imageLink === "") {
              window.open(data.popUp.link, "noopener,noreferrer");
            } else {
              setmodalPopUp(true);
              setTextPopUp(data.popUp);
            }
          } else {
            setmodalPopUp(false);
          }
        } else {
          Handelerror(data.message);
          if (data.popUp !== null) {
            if (data.popUp.text === "" && data.popUp.imageLink === "") {
              window.open(data.popUp.link, "noopener,noreferrer");
            } else {
              setmodalPopUp(true);
              setTextPopUp(data.popUp);
            }
          } else {
            setmodalPopUp(false);
          }
        }
      });
    } catch (ex) {
      console.log(ex);
      HandelShowContentPage("3");
    }
  };
  // لیست همه سفارش های مشتری
  const Orderss = () => {
    setpreButton(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    setpreButton(true);
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.orderList}`;
      const formData = new FormData();
      // formData.append("customerId", Object.values(UseInFo).length > 0 && UseInFo.customerId);
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
      );
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      formData.append("appTypeId", AppType);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        setpreButton(false);
        if (data.code === 200) {
          setapi(data.response);
          Handelerror(data.message);
          if (data.popUp !== null) {
            if (data.popUp.text === "" && data.popUp.imageLink === "") {
              window.open(data.popUp.link, "noopener,noreferrer");
            } else {
              setmodalPopUp(true);
              setTextPopUp(data.popUp);
            }
          } else {
            setmodalPopUp(false);
          }
        } else {
          Handelerror(data.message);
          if (data.popUp !== null) {
            if (data.popUp.text === "" && data.popUp.imageLink === "") {
              window.open(data.popUp.link, "noopener,noreferrer");
            } else {
              setmodalPopUp(true);
              setTextPopUp(data.popUp);
            }
          } else {
            setmodalPopUp(false);
          }
        }
      });
    } catch (ex) {
      console.log(ex);
      HandelShowContentPage("3");
    }
  };

  //وب سرویس ثبت سفارش
  const sabteSefaresh = () => {
    setpreButton(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .post(
        `${baseUrlApiPakhsh}${config.insertOrder}`,
        {
          appTypeId: AppType,
          basketTypeId: 1,
          customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
          deliveryCost: FirstBasket.deliveryCostInt,
          deliveryTimeId: FirstBasket.deliveryTimeId,
          appVersion: browserName,
          AndroidVersion: browserVersion,
          deviceId: UniqueUUID,
        },
        { headers: myheaders },
      )
      .then((response) => {
        setpreButton(false);
        if (response.data.popUp !== null) {
          if (
            response.data.popUp.text === "" &&
            response.data.popUp.imageLink === ""
          ) {
            window.open(response.data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(response.data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        if (response.data.code === 200) {
          countRowBaskett();
          Handelerror(response.data.message);
          loadBasket();
        } else if (response.data.code === 430) {
          Handelerror(response.data.message);
          loadBasket();
        } else if (response.data.code === 401) {
          setshowModalTime(true);
        } else {
          Handelerror(response.data.message);
        }
      })
      .catch((er) => {
        console.log(er);
      });
  };

  //تابع برای کنترل ادد کردن مقدار انتخابی کاربر به سبد خرید
  const handleAddKg = (slug, productRef) => {
    setselectbutton(true);
    if (add.length === 0) {
      setvalidModal(true);
    } else {
      setshowBasket(false);
      setpreCount(true);
      setslugCount(slug);
      setshowPre(true);
      setaddpre(true);
      validate(add, productRef);
    }
  };
  //تابع برای کنترل ادد کردن مقدار انتخابی کاربر  زمانی که در سبد خرید است
  const handleAddKgBasket = (slug, productRef) => {
    setselectbutton(true);
    if (add.length === 0) {
      setvalidModal(true);
    } else {
      setshowBasket(false);
      setpreCount(true);
      setslugCount(slug);
      setshowPre(true);
      setaddpre(true);
      validateBasket(add, productRef);
    }
  };

  useEffect(() => {
    setvalidModal(false);
    if (add.length > 0 && addg.length > 0) {
      setgerami(`${parseInt(add)}${"."}${parseInt(addg)}`);
    } else if (add === 0 && addg.length > 0) {
      setgerami(`${0}${"."}${parseInt(addg)}`);
    } else if (add.length == 0 && addg === 0) {
      setgerami(`${parseInt(add)}${"."}${0}`);
    }
  }, [add, addg]);

  //زمانی که کاربر یکی از مقادیر پیشنهادی مارا امنتخاب میکند وب سرویس را فراخانی میکنیم
  const addBasket = (i) => {
    setresOfSelect([]);
    setforceUpdate(1);
    i.selectSelectOptions = false;
  };
  const addBasket2 = (i) => {
    if (resOfSelect !== null) {
      if (Object.values(addRes).length > 0) {
        addRes.selectOptions.forEach((object) => {
          object.selectSelectOptions = false;
        });
      }
    }
    setresOfSelect(i);
    setforceUpdate(2);
    i.selectSelectOptions = true;
  };

  //تابع برای تایید مقدار پیشنهادی
  const clickAddModalg = (slug) => {
    setshowBasket(false);
    setisorrect(false);
    setpreCount(true);
    setslugCount(slug);
    setshowPre(true);
    setaddpre(true);
    // async function postData() {
    //   let MyTime = Date.now();
    //   let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    //   const myheaders = {
    //     "atu-token": TimeHeader,
    //   };
    //   const url = `${baseUrlApiPakhsh}${config.addToCart}`;
    //   const data = {
    //     mobile: UserPhone.length === 0 ? 0 : UserPhone,
    //     slug: slug,
    //     qty: resOfSelect.selectOptions,
    //     appType: AppType,
    //     deviceId: UniqueUUID,
    //     addressID:
    //       UserPhone.length === 0 || MyDefaultAddress === undefined
    //         ? 0
    //         : MyDefaultAddress.addressId,
    //     directAdd: true,
    //   };

    //   const param = {
    //     method: "Post",
    //     body: JSON.stringify(data),
    //     headers: myheaders,
    //   };
    //   const sendRequest = await fetch(url, param);
    //   const response = await sendRequest.json();
    //   return response;
    // }
    // try {
    //   postData().then((data) => {
    //     setshowPre(false);
    //     setIsLoadingBasket(false);
    //     if (parseInt(data.code) === 200) {
    //       if (showmodalNumBasket === true) {
    //         if (UserPhone.length > 0) {
    //           loadBasket(1);
    //         } else {
    //           handleguestBaskets();
    //         }
    //       }
    //       seshowCountIn(true);
    //       basketProductss();
    //       setshowmodalNum(false);
    //       countRowBaskett();
    //       setAddtoCardResponse(data);
    //       setforceUpdate(3);
    //       setshowPre(false);
    //       setisorrect(false);
    //       setadd([]);
    //       setaddg([]);
    //       setaddpre(false);
    //       setresOfSelect({});
    //       setgerami([]);
    //       setpreCount(false);
    //       setshowmodalNumProduct(false);
    //       setunitProduct([]);
    //       setproductNumBasket([]);
    //       setshowmodalNumBasket(false);
    //       setadd([]);
    //       setaddg([]);
    //     } else if (parseInt(data.code) === 401) {
    //       setshowModalTime(true);
    //     }
    //   });
    // } catch (ex) {
    //   HandelShowContentPage(7);
    //   console.log(ex);
    // }
  };

  const clickAddModalkg = (slug, selectOptions) => {
    setshowBasket(false);
    setisorrect(false);
    setpreCount(true);
    setslugCount(slug);
    setshowPre(true);
    setaddpre(true);

    const handleAddToCardHome = (productNum, selectOptions) => {
      setpre(true);
      setchangeView(true);
      let MyTime = Date.now();
      let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
      const myheaders = {
        "atu-token": TimeHeader,
      };
      axios
        .post(
          `${baseUrlApiPakhsh}${config.addToCart}`,
          {
            appTypeId: AppType,
            customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
            isSet: true,
            price: productNum.price,
            productId: productNum.productRef,
            selection: selectOptions,
            appVersion: browserName,
            AndroidVersion: browserVersion,
            deviceId: UniqueUUID,
          },
          { headers: myheaders },
        )
        .then((response) => {
          if (response.data.popUp !== null) {
            if (
              response.data.popUp.text === "" &&
              response.data.popUp.imageLink === ""
            ) {
              window.open(response.data.popUp.link, "noopener,noreferrer");
            } else {
              setmodalPopUp(true);
              setTextPopUp(response.data.popUp);
            }
          } else {
            setmodalPopUp(false);
          }
          if (response.data.popUp !== null) {
            if (
              response.data.popUp.text === "" &&
              response.data.popUp.imageLink === ""
            ) {
              window.open(response.popUp.link, "noopener,noreferrer");
            } else {
              setmodalPopUp(true);
              setTextPopUp(response.data.popUp);
            }
          } else {
            setmodalPopUp(false);
          }
          if (parseInt(response.data.code, 10) === 200) {
            countRowBaskett();
            setBadgeOfBasket(response.data.response.countInBasket);
            setresAddToCart(response.data.response);
            productNum.basketSelection = response.data.response.selection;
            setpre(false);
            setchangeView(false);
            seshowCountIn(true);
            setshowmodalNum(false);
            countRowBaskett();
            setforceUpdate(3);
            setshowPre(false);
            setisorrect(false);
            setadd([]);
            setaddg([]);
            setaddpre(false);
            setresOfSelect({});
            setgerami([]);
            setpreCount(false);
            setshowmodalNumProduct(false);
            setunitProduct([]);
            setproductNumBasket([]);
            setadd([]);
            setaddg([]);
            setshowmodalNumBasket(false);
            setshowPre(false);
            setIsLoadingBasket(false);
            // offerBoundaryAnimate
            searchProducts.productLists.forEach((object) => {
              object.offerBoundaryAnimate = false;
            });

            if (response.data.response.discountBoundaryProduct.length > 0) {
              for (let i = 0; i < searchProducts.productLists.length; i += 1) {
                if (
                  response.data.response.discountBoundaryProduct.includes(
                    searchProducts.productLists[i],
                  )
                ) {
                  searchProducts.productLists[i].offerBoundaryAnimate = true;
                }
              }
            }
          } else if (parseInt(response.data.code, 10) === 401) {
            setshowModalTime(true);
          }
        })
        .catch((er) => {
          console.log(er);
        });
    };

    handleAddToCardHome(productNum, selectOptions);
  };

  const clickAddModalkgBasket = (slug, selectOptions, id) => {
    setshowBasket(false);
    setisorrect(false);
    setpreCount(true);
    setslugCount(slug);
    setshowPre(true);
    setaddpre(true);

    const handleAddToCardHome = (productNumBasket, selectOptions) => {
      setpre(true);
      setchangeView(true);
      let MyTime = Date.now();
      let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
      const myheaders = {
        "atu-token": TimeHeader,
      };
      axios
        .post(
          `${baseUrlApiPakhsh}${config.addToCart}`,
          {
            appTypeId: AppType,
            customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
            isSet: true,
            price: productNumBasket.price,
            productId: id,
            selection: selectOptions,
            appVersion: browserName,
            AndroidVersion: browserVersion,
            deviceId: UniqueUUID,
          },
          { headers: myheaders },
        )
        .then((response) => {
          if (response.data.popUp !== null) {
            if (
              response.data.popUp.text === "" &&
              response.data.popUp.imageLink === ""
            ) {
              window.open(response.data.popUp.link, "noopener,noreferrer");
            } else {
              setmodalPopUp(true);
              setTextPopUp(response.data.popUp);
            }
          } else {
            setmodalPopUp(false);
          }
          if (response.data.popUp !== null) {
            if (
              response.data.popUp.text === "" &&
              response.data.popUp.imageLink === ""
            ) {
              window.open(response.popUp.link, "noopener,noreferrer");
            } else {
              setmodalPopUp(true);
              setTextPopUp(response.data.popUp);
            }
          } else {
            setmodalPopUp(false);
          }
          if (parseInt(response.data.code, 10) === 200) {
            countRowBaskett();
            setBadgeOfBasket(response.data.response.countInBasket);
            setresAddToCart(response.data.response);
            productNumBasket.selection = response.data.response.selection;
            setpre(false);
            setchangeView(false);
            seshowCountIn(true);
            setshowmodalNum(false);
            countRowBaskett();
            setforceUpdate(3);
            setshowPre(false);
            setisorrect(false);
            setadd([]);
            setaddg([]);
            setaddpre(false);
            setresOfSelect({});
            setgerami([]);
            setpreCount(false);
            setshowmodalNumProduct(false);
            setunitProduct([]);
            setproductNumBasket([]);
            setadd([]);
            setaddg([]);
            setshowmodalNumBasket(false);
            setshowPre(false);
            setIsLoadingBasket(false);

            // offerBoundaryAnimate
            searchProducts.productLists.forEach((object) => {
              object.offerBoundaryAnimate = false;
            });

            if (response.data.response.discountBoundaryProduct.length > 0) {
              for (let i = 0; i < searchProducts.productLists.length; i += 1) {
                if (
                  response.data.response.discountBoundaryProduct.includes(
                    searchProducts.productLists[i],
                  )
                ) {
                  searchProducts.productLists[i].offerBoundaryAnimate = true;
                }
              }
            }
          } else if (parseInt(response.data.code, 10) === 401) {
            setshowModalTime(true);
            setpre(false);
            setchangeView(false);
            seshowCountIn(true);
            setshowmodalNum(false);
            countRowBaskett();
            setforceUpdate(3);
            setshowPre(false);
            setisorrect(false);
            setadd([]);
            setaddg([]);
            setaddpre(false);
            setresOfSelect({});
            setgerami([]);
            setpreCount(false);
            setshowmodalNumProduct(false);
            setunitProduct([]);
            setproductNumBasket([]);
            setadd([]);
            setaddg([]);
            setshowmodalNumBasket(false);
            setshowPre(false);
            setIsLoadingBasket(false);
          } else {
            setpre(false);
            setchangeView(false);
            seshowCountIn(true);
            setshowmodalNum(false);
            countRowBaskett();
            setforceUpdate(3);
            setshowPre(false);
            setisorrect(false);
            setadd([]);
            setaddg([]);
            setaddpre(false);
            setresOfSelect({});
            setgerami([]);
            setpreCount(false);
            setshowmodalNumProduct(false);
            setunitProduct([]);
            setproductNumBasket([]);
            setadd([]);
            setaddg([]);
            setshowmodalNumBasket(false);
            setshowPre(false);
            setIsLoadingBasket(false);
            Handelerror(response.data.message);
          }
        })
        .catch((er) => {
          console.log(er);
        });
    };

    handleAddToCardHome(productNum, selectOptions);
  };

  const HandelShowContentPagecode = (name) => {
    let contentPageValue = [...getcontentPage];
    contentPageValue = name;
    setcontentPage(contentPageValue);
    let toastContent = "";
    toastContent = name;
    setToast(toastContent);
    setShowToast(true);
  };

  const removeCross = () => {
    setshowPre(false);
    setisorrect(false);
    setadd([]);
    setaddg([]);
    setaddpre(false);
    setresOfSelect({});
    setgerami([]);
    setpreCount(false);
    setshowmodalNumProduct(false);
    setunitProduct([]);
    setproductNumBasket([]);
    setshowmodalNumBasket(false);
    setshowmodalNum(false);
  };

  const notExistCustomer = () => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .get(`${baseUrlApiPakhsh}${config.notExistCustomerMessage}`, {
        headers: myheaders,
      })
      .then((response) => {
        setnotExistRes(response.data.response);
      })
      .catch((er) => {
        console.log(er);
      });
  };

  const support = () => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .get(`${baseUrlApiPakhsh}${config.supportPhone}`, {
        headers: myheaders,
      })
      .then((response) => {
        setphoneOfSupport(response.data.response);
      })
      .catch((er) => {
        console.log(er);
      });
  };

  //وب سرویس basketSetValidater برای چک کردن
  //مقدار وارد شده توسط کاربر برای ادد کردن به سبد خرید
  const validate = (userSelection, productRef) => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .post(
        `${baseUrlApiPakhsh}${config.basketSetValidater}`,
        {
          productId: productRef,
          customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
          selection: userSelection,
          appVersion: browserName,
          AndroidVersion: browserVersion,
          deviceId: UniqueUUID,
          appTypeId: AppType,
        },
        { headers: myheaders },
      )
      .then((response) => {
        // setpreButton(false);

        // if (data.popUp !== null) {
        //   if (
        //     data.popUp.text === "" &&
        //    data.popUp.imageLink === ""
        //   ) {
        //     window.open(data.popUp.link, "noopener,noreferrer");
        //   } else {
        //     setmodalPopUp(true);
        //     setTextPopUp(data.popUp);
        //   }
        // } else {
        //   setmodalPopUp(false);
        // }
        // alert("onja");
        if (response.data.code === 200) {
          setaddpre(false);
          setaddRes(response.data.response);
          if (response.data.response.isCorrect === true) {
            setshowPre(true);
            setIsLoadingBasket(true);

            //وب سرویس ادد تو کارت
            setpre(true);
            setchangeView(true);
            let MyTime = Date.now();
            let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
            const myheaders = {
              "atu-token": TimeHeader,
            };
            axios
              .post(
                `${baseUrlApiPakhsh}${config.addToCart}`,
                {
                  appTypeId: AppType,
                  customerId:
                    Object.values(UseInFo).length > 0 && UseInFo.customerId,
                  isSet: true,
                  price: productNum.price,
                  productId: productNum.productRef,
                  selection: userSelection,
                  appVersion: browserName,
                  AndroidVersion: browserVersion,
                  deviceId: UniqueUUID,
                },
                { headers: myheaders },
              )
              .then((response) => {
                if (response.data.popUp !== null) {
                  if (
                    response.data.popUp.text === "" &&
                    response.data.popUp.imageLink === ""
                  ) {
                    window.open(
                      response.data.popUp.link,
                      "noopener,noreferrer",
                    );
                  } else {
                    setmodalPopUp(true);
                    setTextPopUp(response.data.popUp);
                  }
                } else {
                  setmodalPopUp(false);
                }
                if (response.data.popUp !== null) {
                  if (
                    response.data.popUp.text === "" &&
                    response.data.popUp.imageLink === ""
                  ) {
                    window.open(response.popUp.link, "noopener,noreferrer");
                  } else {
                    setmodalPopUp(true);
                    setTextPopUp(response.data.popUp);
                  }
                } else {
                  setmodalPopUp(false);
                }
                if (parseInt(response.data.code, 10) === 200) {
                  countRowBaskett();
                  setBadgeOfBasket(response.data.response.countInBasket);
                  setresAddToCart(response.data.response);
                  productNum.basketSelection = response.data.response.selection;
                  setpre(false);
                  setchangeView(false);
                  seshowCountIn(true);
                  setshowmodalNum(false);
                  countRowBaskett();
                  setforceUpdate(3);
                  setshowPre(false);
                  setisorrect(false);
                  setadd([]);
                  setaddg([]);
                  setaddpre(false);
                  setresOfSelect({});
                  setgerami([]);
                  setpreCount(false);
                  setshowmodalNumProduct(false);
                  setunitProduct([]);
                  setproductNumBasket([]);
                  setadd([]);
                  setaddg([]);
                  setshowmodalNumBasket(false);
                  setshowPre(false);
                  setIsLoadingBasket(false);

                  // offerBoundaryAnimate
                  searchProducts.productLists.forEach((object) => {
                    object.offerBoundaryAnimate = false;
                  });

                  if (
                    response.data.response.discountBoundaryProduct.length > 0
                  ) {
                    for (
                      let i = 0;
                      i < searchProducts.productLists.length;
                      i += 1
                    ) {
                      if (
                        response.data.response.discountBoundaryProduct.includes(
                          searchProducts.productLists[i],
                        )
                      ) {
                        searchProducts.productLists[i].offerBoundaryAnimate =
                          true;
                      }
                    }
                  }
                } else if (parseInt(response.data.code, 10) === 401) {
                  setshowModalTime(true);
                }
              })
              .catch((er) => {
                console.log(er);
              });
          } else if (response.data.response.isCorrect === false) {
            setisorrect(true);
          }
        } else if (response.data.code === 500) {
          setaddpre(false);
          HandelShowContentPagecode(response.data.message);
        } else if (response.data.code === 401) {
          setshowModalTime(true);
        }
      })
      .catch((er) => {
        console.log(er);
      });
  };

  const validateBasket = (userSelection, productRef) => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .post(
        `${baseUrlApiPakhsh}${config.basketSetValidater}`,
        {
          productId: productRef,
          customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
          selection: userSelection,
          appVersion: browserName,
          AndroidVersion: browserVersion,
          deviceId: UniqueUUID,
          appTypeId: AppType,
        },
        { headers: myheaders },
      )
      .then((response) => {
        // setpreButton(false);

        // if (data.popUp !== null) {
        //   if (
        //     data.popUp.text === "" &&
        //    data.popUp.imageLink === ""
        //   ) {
        //     window.open(data.popUp.link, "noopener,noreferrer");
        //   } else {
        //     setmodalPopUp(true);
        //     setTextPopUp(data.popUp);
        //   }
        // } else {
        //   setmodalPopUp(false);
        // }
        // alert("onja");
        if (response.data.code === 200) {
          setaddpre(false);
          setaddRes(response.data.response);
          if (response.data.response.isCorrect === true) {
            setshowPre(true);
            setIsLoadingBasket(true);

            //وب سرویس ادد تو کارت
            setpre(true);
            setchangeView(true);
            let MyTime = Date.now();
            let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
            const myheaders = {
              "atu-token": TimeHeader,
            };
            axios
              .post(
                `${baseUrlApiPakhsh}${config.addToCart}`,
                {
                  appTypeId: AppType,
                  customerId:
                    Object.values(UseInFo).length > 0 && UseInFo.customerId,
                  isSet: true,
                  price: productNumBasket.salePrice,
                  productId: productNumBasket.productId,
                  selection: userSelection,
                  appVersion: browserName,
                  AndroidVersion: browserVersion,
                  deviceId: UniqueUUID,
                },
                { headers: myheaders },
              )
              .then((response) => {
                if (response.data.popUp !== null) {
                  if (
                    response.data.popUp.text === "" &&
                    response.data.popUp.imageLink === ""
                  ) {
                    window.open(
                      response.data.popUp.link,
                      "noopener,noreferrer",
                    );
                  } else {
                    setmodalPopUp(true);
                    setTextPopUp(response.data.popUp);
                  }
                } else {
                  setmodalPopUp(false);
                }
                if (response.data.popUp !== null) {
                  if (
                    response.data.popUp.text === "" &&
                    response.data.popUp.imageLink === ""
                  ) {
                    window.open(response.popUp.link, "noopener,noreferrer");
                  } else {
                    setmodalPopUp(true);
                    setTextPopUp(response.data.popUp);
                  }
                } else {
                  setmodalPopUp(false);
                }
                if (parseInt(response.data.code, 10) === 200) {
                  countRowBaskett();
                  setBadgeOfBasket(response.data.response.countInBasket);
                  setresAddToCart(response.data.response);
                  productNumBasket.selection = response.data.response.selection;
                  setpre(false);
                  setchangeView(false);
                  seshowCountIn(true);
                  setshowmodalNum(false);
                  countRowBaskett();
                  setforceUpdate(3);
                  setshowPre(false);
                  setisorrect(false);
                  setadd([]);
                  setaddg([]);
                  setaddpre(false);
                  setresOfSelect({});
                  setgerami([]);
                  setpreCount(false);
                  setshowmodalNumProduct(false);
                  setunitProduct([]);
                  setproductNumBasket([]);
                  setadd([]);
                  setaddg([]);
                  setshowmodalNumBasket(false);
                  setshowPre(false);
                  setIsLoadingBasket(false);

                  // offerBoundaryAnimate
                  searchProducts.productLists.forEach((object) => {
                    object.offerBoundaryAnimate = false;
                  });

                  if (
                    response.data.response.discountBoundaryProduct.length > 0
                  ) {
                    for (
                      let i = 0;
                      i < searchProducts.productLists.length;
                      i += 1
                    ) {
                      if (
                        response.data.response.discountBoundaryProduct.includes(
                          searchProducts.productLists[i],
                        )
                      ) {
                        searchProducts.productLists[i].offerBoundaryAnimate =
                          true;
                      }
                    }
                  }
                } else if (parseInt(response.data.code, 10) === 401) {
                  setshowModalTime(true);
                }
              })
              .catch((er) => {
                console.log(er);
              });
          } else if (response.data.response.isCorrect === false) {
            setisorrect(true);
          }
        } else if (response.data.code === 500) {
          setaddpre(false);
          HandelShowContentPagecode(response.data.message);
        } else if (response.data.code === 401) {
          setshowModalTime(true);
        }
      })
      .catch((er) => {
        console.log(er);
      });
  };

  //وب سرویس لیست برندهایی که تخفیف دارند\
  const disBrands = () => {
    setpreButton(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .post(
        `${baseUrlApiPakhsh}${config.discountedBrands}`,
        {
          customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
          appTypeId: AppType,
          discountIds: [],
          appVersion: browserName,
          AndroidVersion: browserVersion,
          deviceId: UniqueUUID,
        },
        { headers: myheaders },
      )
      .then((response) => {
        setpreButton(false);
        if (response.data.popUp !== null) {
          if (
            response.data.popUp.text === "" &&
            response.data.popUp.imageLink === ""
          ) {
            window.open(response.data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(response.data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        if (response.data.code === 200) {
          setpreButton(false);
          setbrandsOfDis(response.data.response);
        } else if (response.data.code === 401) {
          setpreButton(false);
          setshowModalTime(true);
        } else {
          setpreButton(false);
          Handelerror(response.data.message);
        }
      })
      .catch((er) => {
        setpreButton(false);
        console.log(er);
      });
  };

  //وب سرویس جزئیات محصول
  const productDetails = (id) => {
    setshowPrepage(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.productDetail}`;
      const formData = new FormData();
      formData.append("productId", id);
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
      );
      formData.append("appTypeId", AppType);
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        setshowPrepage(false);
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }

        if (data.code === 200) {
          setproductsDetails(data.response);
        } else if (data.code === 400) {
          Handelerror(data.message);
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  //وب سرویس افزودن کالا به لیست مورد علاقه
  const goFavorate = (id, productFav) => {
    setshowPrepage(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .post(
        `${baseUrlApiPakhsh}${config.makeFavorite}`,
        {
          productId: id,
          fave: productFav,
          customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
          appVersion: browserName,
          AndroidVersion: browserVersion,
          deviceId: UniqueUUID,
          appTypeId: AppType,
        },
        { headers: myheaders },
      )
      .then((response) => {
        // if (response.popUp !== null) {
        //   if (response.popUp.text === "" && response.popUp.imageLink === "") {
        //     window.open(response.popUp.link, "noopener,noreferrer");
        //   } else {
        //     setmodalPopUp(true)
        //     setTextPopUp(response.popUp);
        //   }
        // } else {
        //   setmodalPopUp(false);
        // }
        if (response.data.code === 200) {
          Handelerror(response.data.message);
          productDetails(id);
        } else if (response.data.code === 401) {
          setshowModalTime(true);
        } else {
          Handelerror(response.data.message);
        }
      })
      .catch((er) => {
        console.log(er);
      });
  };

  //تابع برای اینکه همیشه اسکرول از سمت بالا شروع شود
  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let ss = window.location.href.split("/");
    if (ss[ss.length - 1] === "tarhha") {
      disBrands();
    }
  }, [window.location.href]);

  // اپی کالا/ وب سرویس جزییات سفارش
  const goOrders = (id) => {
    setorderDetailId(id);
    setshowPrepage(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .post(
        `${baseUrlApiPakhsh}${config.kfpOrderDetail}`,
        {
          customerId: Object.values(UseInFo).length > 0 && UseInFo.customerId,
          orderId: id,
          appVersion: browserName,
          AndroidVersion: browserVersion,
          deviceId: UniqueUUID,
          appTypeId: AppType,
        },
        { headers: myheaders },
      )
      .then((response) => {
        setshowPrepage(false);
        if (response.data.popUp !== null) {
          if (
            response.data.popUp.text === "" &&
            response.data.popUp.imageLink === ""
          ) {
            window.open(response.data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(response.data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        if (response.data.code === 200) {
          setorderDetailKfp(response.data.response);
        } else if (response.data.code === 401) {
          setshowModalTime(true);
        } else {
          Handelerror(response.data.message);
        }
      })
      .catch((er) => {
        console.log(er);
      });
  };

  // اپی پخش /وب سرویس جزییات سفارش
  const details = (orderid) => {
    setorderDetailApi([]);
    setorderDetailId(orderid);
    setshowPrepage(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.apipakhshOrderDetail}`;
      const formData = new FormData();
      formData.append(
        "customerId",
        Object.values(UseInFo).length > 0 && UseInFo.customerId,
      );
      formData.append("orderId", orderid);
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      formData.append("appTypeId", AppType);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        setshowPrepage(false);
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        if (data.code === 200) {
          setorderDetailApi(data.response);
        } else {
          setorderDetailApi([]);
          Handelerror(data.message);
        }
      });
    } catch (ex) {
      setorderDetailApi([]);
    }
  };

  //تابع برای اینکه در قسمت طرح ها همیشه اولین بار تمام طرح ها نمایش داده شود.
  useEffect(() => {
    setBrandIdForUser(-1);
    setgoBrand(false);
    setSearchField("");
  }, [window.location.href]);

  //ui تنظیمات
  useEffect(() => {
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .get(`${baseUrlApiPakhsh}${config.uiSetting}`, {
        headers: myheaders,
      })
      .then((response) => {
        setuisetting(response.data.response);
      })
      .catch((er) => {
        console.log(er);
      });
  }, []);

  //تابع برای زمانی که کاربرازطریق لینک به صفحه ثبت لوکیشن وارد میشود
  useEffect(() => {
    let url = window.location.href.split("/")[4];
    if (url === "userLocation") {
      let mainUrl = window.location.href.split("/")[5].split("&");
      setuserIdMap(parseInt(mainUrl[0].split("=")[1]));
      setuserCodeMap(parseInt(mainUrl[1].split("=")[1]));
      setuserPhoneMap(parseInt(mainUrl[2].split("=")[1]));
      setlatCenter(parseFloat(mainUrl[3].split("=")[1]));
      setlangCenter(parseFloat(mainUrl[4].split("=")[1]));
      setUserLat(parseFloat(mainUrl[3].split("=")[1]));
      setUserLang(parseFloat(mainUrl[4].split("=")[1]));
    }
  }, []);

  useEffect(() => {
    let url = window.location.href.split("/")[4];
    if (url === "userLocation") {
      let mainUrl = window.location.href.split("/")[5].split("&");
      setuserIdMap(parseInt(mainUrl[0].split("=")[1]));
      setuserCodeMap(parseInt(mainUrl[1].split("=")[1]));
      setuserPhoneMap(parseInt(mainUrl[2].split("=")[1]));
      setlatCenter(parseFloat(mainUrl[3].split("=")[1]));
      setlangCenter(parseFloat(mainUrl[4].split("=")[1]));
      setUserLat(parseFloat(mainUrl[3].split("=")[1]));
      setUserLang(parseFloat(mainUrl[4].split("=")[1]));
    }
  }, [window.location.href]);

  const postloc = () => {
    setmapLoader(true);
    let MyTime = Date.now();
    let TimeHeader = Encriptor(MyTime + timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${baseUrlApiPakhsh}${config.getCustomerLocation}`;
      const formData = new FormData();
      formData.append("customerLat", UserLat);
      formData.append("customerLong", UserLang);
      formData.append("customerId", userIdMap);
      formData.append("customerCode", userCodeMap);
      formData.append("customerMobile", userPhoneMap);
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", UniqueUUID);
      formData.append("appTypeId", AppType);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        setshowPrepage(false);
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            setmodalPopUp(true);
            setTextPopUp(data.popUp);
          }
        } else {
          setmodalPopUp(false);
        }
        if (data.code === 200) {
          setmapLoader(false);
          setloc(true);
          setloctest(data.message);
        } else {
          setloc(true);
          setloctest(data.message);
          setmapLoader(false);
        }
      });
    } catch (ex) {
      setmapLoader(false);
    }
  };
  //نمایش پیغام وب سرویس ها
  const handleError = (name) => {
    setError(true);
    setToastMsge(name);
  };

  return (
    <div className="main">
      <SimpleContext.Provider
        value={{
          CatLoader,
          setCatLoader,
          goBrand,
          setgoBrand,
          uisetting,
          setuisetting,
          orderDetailId,
          setorderDetailId,
          orderDetailKfp,
          setorderDetailKfp,
          orderDetailApi,
          setorderDetailApi,
          goOrders,
          page,
          setpage,
          searchBodyOfProduct,
          setsearchBodyOfProduct,
          goFavorate,
          showPrepage,
          setshowPrepage,
          productRoight,
          setproductRoight,
          productsDetails,
          setproductsDetails,
          productDetails,
          AppType,
          setAppType,
          BrandIdForUser,
          setBrandIdForUser,
          brandsOfDis,
          setbrandsOfDis,
          disBrands,
          showCountIn,
          seshowCountIn,
          detailsOfOrders,
          setdetailsOfOrders,
          details,
          phoneOfSupport,
          setphoneOfSupport,
          support,
          notExistRes,
          setnotExistRes,
          notExistCustomer,
          gerami,
          setgerami,
          unitProduct,
          setunitProduct,
          showmodalNum,
          setshowmodalNum,
          addpre,
          setaddpre,
          addRes,
          setaddRes,
          addg,
          setaddg,
          add,
          setadd,
          resOfSelect,
          setresOfSelect,
          showmodalNumProduct,
          setshowmodalNumProduct,
          showmodalNumBasket,
          setshowmodalNumBasket,
          productNumBasket,
          setproductNumBasket,
          IsLoadingBasket,
          setIsLoadingBasket,
          preCount,
          setpreCount,
          selectbutton,
          setselectbutton,
          validModal,
          setvalidModal,
          productNum,
          setproductNum,
          dis,
          setdis,
          bouhgt,
          setbouhgt,
          fave,
          setfave,
          rullsText,
          setrullsText,
          festivalData,
          setFestivalData,
          sabteSefaresh,
          showapi,
          setShowApi,
          showKfp,
          setShowKfp,
          Kfp,
          setKfp,
          api,
          setapi,
          KfPorder,
          CustomerOrder,
          handleAddToCardD,
          IsLoggeCode,
          setIsLoggeCode,
          IsLoggedWithSms,
          setIsLoggedWithSms,
          loginUser2,
          enterpassUser,
          setenterpassUser,
          modify,
          userPassword,
          setuserPassword,
          // Pass,
          // setPass,
          ConfirmPass,
          setConfirmPass,
          setPassModal,
          setsetPassModal,
          codeOfUser,
          setcodeofUser,
          loginUser,
          sendCode,
          Orderss,
          enterpass,
          setenterpass,
          preButton,
          setpreButton,
          errorText,
          seterrorText,
          errorshow,
          seterrorshow,
          checkcustomer,
          showChat,
          latCenter,
          setlatCenter,
          langCenter,
          setlangCenter,
          userIdMap,
          setuserIdMap,
          setshowChat,
          HandelShowContentPage2,
          ToastError,
          setToastError,
          Handelerror,
          countRowBaskett,
          BadgeOfBasket,
          setBadgeOfBasket,
          BrandOfId,
          setBrandOfId,
          brandName,
          setbrandName,
          changeView,
          setchangeView,
          toast,
          setToast,
          showToast,
          setShowToast,
          showToast2,
          setShowToast2,
          sort,
          setsort,
          sortOrder,
          List,
          setList,
          showBrand,
          setshowBrand,
          homepageBanner,
          justFav,
          setjustFav,
          sethomepageBanner,
          gethomepage,
          getBrands,
          getBrandsList,
          setgetBrandsList,
          showCatId,
          setshowCatId,
          headerCat,
          setheaderCat,
          TextPopUp,
          setTextPopUp,
          link,
          setlink,
          modalPopUp,
          setmodalPopUp,
          discountStep,
          setdiscountStep,
          showCat,
          setshowCat,
          categories,
          TarhaTitle,
          setTarhaTitle,
          deleteAllBrandsInSearch,
          setdeleteAllBrandsInSearch,
          SearchBrandsSelection,
          setSearchBrandsSelection,
          show,
          setshow,
          MyId,
          setMyId,
          SelectedBrandsList,
          setSelectedBrandsList,
          FilterPriceRange,
          setFilterPriceRange,
          TreeMenuSelectedId,
          setTreeMenuSelectedId,
          showfield,
          setshowfield,
          SearchField,
          setSearchField,
          Tarha,
          setTarha,
          tarh,
          pre,
          setpre,
          resAddToCart,
          setresAddToCart,
          handleAddToCard,
          search,
          timeMiliSecondRes,
          settimeMiliSecondRes,
          timeMiliSecondDef,
          settimeMiliSecondDef,
          baseUrlApiPakhsh,
          Encriptor,
          showPre,
          setshowPre,
          UniqueUUID,
          setUniqueUUID,
          MyBasketItems,
          setMyBasketItems,
          showModalTime,
          setshowModalTime,
          FirstBasket,
          setFirstBasket,
          basket,
          setBasket,
          basketloader,
          setbasketloader,
          resAdd,
          setresAdd,
          loadBasket,
          theme,
          searchProducts,
          setsearchProducts,
          Acts,
          brands,
          tarikh,
          products,
          category,
          searchtxt,
          SimplePrd,
          allProducts,
          catNameHeader,
          userCodeMap,
          setuserCodeMap,
          userPhoneMap,
          setuserPhoneMap,
          tarikhTahvilKala,
          productNameHeader,
          FreshProductsList,
          ShopedProductList,
          Discount: getDiscount,
          category3C: categorylev3,
          productCopy: getProductsC,
          sideDrawer: getsideDrawer,
          contentPage: getcontentPage,
          offerBanners: getofferBanners,
          TarhdarDrawer: getTarhdarDrawer,
          ProductDrawer: getProductDrawer,
          SearchDrawer: getSearchDrawer,
          category_two: getCategorylev2C,
          DiscountGroups: getDiscountGroups,
          FirstPageTotal: getFirstPageTotal,
          FilteredTarhydar: getFilteredTarhydar,
          productsLevel2: getProductsC_Levtwo,
          FreshListFSearch: getFreshListFSearch,
          SearchedProducts: getSearchedProducts,
          FreshSearchDrawer: getFreshSearchDrawer,
          FilteredByImgTarh: getFilteredByImgTarh,
          FreshSearchedProducts: getFreshSearchedProducts,
          FestivalDataPoints,
          setFestivalDataPoints,
          myTarhs,
          setmyTarhs,
          Maximum,
          setMaximum,
          getVaranegarOrderResponse,
          setgetVaranegarOrderResponse,
          SinglePrdCategory,
          setSinglePrdCategory,
          SinglePrdCategory2,
          setSinglePrdCategory2,
          MainCat,
          setMainCat,
          setfreshSearchtxt,
          freshSearchtxt,
          IsShowOne: getIsShowOne,
          setIsShowOne,
          setimagenames,
          imagenames: getimagenames,
          bannerProduct,
          setbannerProduct,
          hi,
          setHi,
          Listt,
          setListt,
          verCode,
          setVerCode,
          myinfo,
          setmyinfo,
          TarhdarImages: getTarhdarImages,
          setTarhdarImages,
          Error,
          setError,
          ToastMsge,
          setToastMsge,
          setClicked,
          clicked,
          loopArr,
          row1,
          setrow1,
          row2,
          setrow2,
          row3,
          setrow3,
          row4,
          setrow4,
          row5,
          setrow5,
          row6,
          setrow6,
          row7,
          setrow7,
          row8,
          setrow8,
          DiscCode,
          setDiscCode,
          setOffers,
          Offers,
          CartItems,
          setCartItems,
          FRESHCartItems,
          setFRESHCartItems,
          badgeNum,
          PrdCount,
          setModalShow,
          modalShow,
          setNumUnitDiscount,
          NumUnitDiscount,
          setStyle,
          style,
          setNumber,
          number,
          SumTarh,
          FullDate,
          setTTotalPrice,
          TTotalPrice,
          setFreshTTotalPrice,
          postloc,
          FreshTTotalPrice,
          setSabadResponse,
          SabadResponse,
          setFreshSabadResponse,
          FreshSabadResponse,
          MyList,
          ApiFactors,
          setApiFactors,
          KFPfactors,
          setKFPfactors,
          Freshfactors,
          buttontitle,
          setButtontitle,
          setFreshfactors,
          UseInFo,
          setUseInFo,
          StockProduct,
          setStockProduct,
          FreshStockProduct,
          setFreshStockProduct,
          bothId,
          setbothId,
          mapLoader,
          setmapLoader,
          varaanegar_stock,
          ApiSetting,
          getInsertOrderResponse,
          setgetInsertOrderResponse,
          FreshInsertOrderResponse,
          setFreshInsertOrderResponse,
          TarhNameHeader,
          ApiFactorResponse,
          setApiFactorResponse,
          KFPFactorResponse,
          UserLang,
          setUserLang,
          UserLat,
          setUserLat,
          setKFPFactorResponse,
          PreOrderFactorResponse,
          setPreOrderFactorResponse,
          DeliveryDateFresh,
          IsLoggedIn,
          setIsLoggedIn,
          IsLoggedIn2,
          setIsLoggedIn2,
          NotRegisteredAtCO,
          setNotRegisteredAtCO,
          getFinalFreshResponse,
          setFinalFreshResponse,
          click,
          setsearchtxt,
          handleAddProduct,
          handleOpenSearch,
          clearLocalStorage,
          handleHistoryPush,
          handleCloseSearch,
          handleCloseSidebar,
          handleRemoveProduct,
          handleTarhdarDrawer,
          handleProductDrawer,
          handleFilterTarhDar,
          handleHistoryreplace,
          handleFilterProducts,
          handleFilterCategory,
          handleSearchProducts,
          backdropClickHandler,
          setShopedProductList,
          handleFilterByCatName,
          HandelShowContentPage,
          homepageOnClickBanners,
          handleCloseFreshSearch,
          handleShowFilteredTarhs,
          handleShowSimpleProduct,
          handleShowShopedProducts,
          drawerToggleClickHandler,
          handleDeleteItemFromSabad,
          handleFilteredFreshSearched,
          handleShowTrhsFilteredBySlugName,
          handleShowCategoryLevelTwoProducts,
          handleShowCategoryLevelThreeProducts,
          AddBasketFromSimpleProductSlider,
          handleDeleteFRESHItemFromSabad,
          FRESHbadgeNum,
          handleAddFRESHProduct,
          handleRemoveFRESHProduct,
          handleError,
          Varanegar_Discountfresh,
          Varanegar_Discount,
          festivalPont,
          callPoints,
        }}
      >
        {
          // IsLoggedIn === true && IsLoggeCode === true && IsLoggedWithSms===true ?

          location.pathname === "/Buy" ||
          location.pathname === "/Brands" ||
          location.pathname === "/Brands" ||
          location.pathname === "/homePage" ||
          location.pathname === "/tarhha" ? (
            <Header />
          ) : null
          //  : null
        }

        <SideBar />

        {backDrop}

        <TitleBox />

        {IsLoggedIn === true ? (
          location.pathname === "/Categories" ||
          location.pathname === "/Buy" ||
          location.pathname === "/Brands" ||
          location.pathname === "/tarhha" ||
          location.pathname === "/homePage" ||
          location.pathname === "/CategoriesProducts" ? (
            <Footer />
          ) : null
        ) : null}
      </SimpleContext.Provider>

      <Modal style={{ marginTop: "180px" }} show={modalPopUp}>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {TextPopUp.imageLink !== "" && (
            <img
              style={{ width: "100%", height: "30vh" }}
              src={TextPopUp.imageLink}
            />
          )}
          <p
            style={{
              fontWeight: "bold",
              width: "100%",
              padding: "15px 0 15px 0",
              textAlign: "center",
              borderBottom: "1px solid #e5e5e5",
              margin: "0",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {TextPopUp.text}
          </p>
          <Button
            onClick={() => closeModalPop()}
            style={{
              width: "90%",
              display: "flex",
              justifyContent: "center",
              backgroundColor: "#ff7014",
              border: "none",
              margin: "15px 0 15px 0",
            }}
          >
            {TextPopUp.buttonText}
          </Button>
        </div>
      </Modal>
      <Modal
        style={{
          marginTop: "180px",
          marginTop: "180px",
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          alignItems: "center",
        }}
        className="MyModal"
        show={showToast}
      >
        <Modal.Body style={{ height: "10vh", padding: "10%" }}>
          <div>
            <img
              alt="toast"
              style={{
                width: "25%",
                marginTop: "-25%",
                backgroundColor: " #fff",
                padding: " 1%",
                border: " 1px solid gray",
                borderRadius: "5px",
              }}
              src={unsuccess}
            />
          </div>

          <p
            style={{
              textAlign: "center",
              margin: "-3% 0 0 0",
              fontWeight: "bold",
              fontSize: "13px",
            }}
          >
            {toast}
          </p>
        </Modal.Body>

        <Button
          style={{
            width: "100%",
            backgroundColor: "red",
            border: "none",
            borderRadius: "0",
          }}
          onClick={() => handleClose()}
        >
          بستن
        </Button>
      </Modal>

      <Modal
        style={{
          marginTop: "180px",
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          alignItems: "center",
        }}
        className="MyModal"
        show={showToast2}
      >
        <Modal.Body style={{ height: "10vh", padding: "10%" }}>
          <div>
            <img
              alt="toast"
              style={{
                width: "25%",
                marginTop: "-25%",
                backgroundColor: " #fff",
                padding: " 1%",
                border: " 1px solid gray",
                borderRadius: "5px",
              }}
              src={success}
            />
          </div>

          <p
            style={{
              textAlign: "center",
              margin: "-3% 0 0 0",
              fontWeight: "bold",
              fontSize: "13px",
            }}
          >
            {toast}
          </p>
        </Modal.Body>

        <Button
          style={{
            width: "100%",
            backgroundColor: "green",
            border: "none",
            borderRadius: "0",
          }}
          onClick={() => handleClose2()}
        >
          تایید
        </Button>
      </Modal>

      {/* مودال برای وارد کردن مقدار */}
      <Modal style={{ marginTop: "180px" }} show={showmodalNum}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {addpre === false && preCount === false ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                height: "5vh",
                justifyContent: "flex-start",
                alignItems: "center",
                textAlign: "center",
                borderBottom: "1px solid #dddbdb",
              }}
            >
              <img
                style={{
                  width: "20px",
                  marginRight: "5%",
                  cursor: "pointer",
                }}
                onClick={() => removeCross()}
                src={cross}
              />
            </div>
          ) : null}
          {/* این قسمت برای زمانی است که به کاربر یک مقدار انتخابی پیشنهاد میدهیم */}
          {iscorrect === true ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textAlign: "center",
                  borderBottom: "1px solid #dddbdb",
                }}
              >
                {productNum.imageUrl !== "" ? (
                  <img
                    style={{
                      width: "120px",
                      borderLeft: "1px solid #dddbdb",
                      margin: " 5% 0 5% 0",
                    }}
                    src={productNum.imageUrl}
                  />
                ) : (
                  <img
                    style={{
                      width: "160px",
                      borderLeft: "1px solid #dddbdb",
                      margin: " 5% 0 5% 0",
                    }}
                    // src={placeH}
                  />
                )}
                <p
                  style={{
                    width: "100%",
                    paddingRight: "5%",
                    display: "flex",
                    fontWeight: "bold",
                    color: "gray",
                    fontSize: "18px",
                    margin: "0",
                  }}
                >
                  {productNum.productName}
                </p>
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textAlign: "center",
                  borderBottom: "1px solid #dddbdb",
                }}
              >
                <p
                  style={{
                    width: "100%",
                    padding: "5%",
                    display: "flex",
                    fontWeight: "bold",
                    color: "#000",
                    fontSize: "15px",
                    margin: "0",
                    display: "flex",
                  }}
                >
                  {addRes.message}
                </p>
              </div>

              <div
                style={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  borderBottom: "1px solid #dddbdb",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  {addRes.selectOptions.map((i) =>
                    i.selectSelectOptions === true ? (
                      <button
                        className="btnModalAddToCart"
                        onClick={() => addBasket(i)}
                        style={{
                          width: "100%",
                          display: "flex",
                          margin: "5% 0 0 0",
                          borderRadius: "20px",
                          height: "5vh",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          border: "1px solid #ff7014",
                          fontWeight: "bold",
                          color: "#ff7014",
                        }}
                      >
                        {i.selectView}
                      </button>
                    ) : (
                      <button
                        className="btnModalAddToCart"
                        onClick={() => addBasket2(i)}
                        style={{
                          width: "100%",
                          display: "flex",
                          margin: "5% 0 0 0%",
                          borderRadius: "20px",
                          height: "5vh",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          border: "1px solid gray",
                          fontWeight: "bold",
                          color: "gray",
                        }}
                      >
                        {i.selectView}
                      </button>
                    ),
                  )}
                </div>
                {resOfSelect !== null &&
                Object.values(resOfSelect).length > 0 ? (
                  <button
                    onClick={() =>
                      clickAddModalkg(
                        productNum.slug,
                        resOfSelect.selectOptions,
                      )
                    }
                    className="btnModalAdd"
                    style={{
                      width: "100%",
                      display: "flex",
                      margin: "5%",
                      borderRadius: "20px",
                      height: "5vh",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      border: "1px solid #ff7014",
                      fontWeight: "bold",
                      color: "#fff",
                      backgroundColor: "#ff7014",
                    }}
                  >
                    تایید
                  </button>
                ) : (
                  <button
                    style={{
                      width: "100%",
                      display: "flex",
                      margin: "5%",
                      borderRadius: "20px",
                      height: "5vh",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      border: "1px solid gray",
                      fontWeight: "bold",
                      color: "#fff",
                      backgroundColor: "gray",
                    }}
                  >
                    تایید
                  </button>
                )}
              </div>
            </div>
          ) : //  مرحله اول که کاربر میخواهد یک مقدار را وارد کند
          addpre === true || preCount === true ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                border: "none",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                gap: "20px",
              }}
            >
              <p
                style={{
                  alignItems: "flex-start",
                  height: "20vh",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  textAlign: "center",
                  margin: "0",
                  fontWeight: "bold",
                  color: "gray",
                  fontSize: "17px",
                }}
              >
                لطفا کمی صبر کنید...
              </p>
              <div
                style={{
                  height: "20vh",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  textAlign: "center",
                  margin: "0",
                  fontWeight: "bold",
                  color: "gray",
                  fontSize: "17px",
                }}
              >
                <Preloader3 />
              </div>
            </div>
          ) : (
            <>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textAlign: "center",
                  borderBottom: "1px solid #dddbdb",
                }}
              >
                {productNum.imageUrl !== "" ? (
                  <img
                    onError={addDefaultSrc}
                    style={{
                      width: "160px",
                      borderLeft: "1px solid #dddbdb",
                      margin: " 5% 0 5% 0",
                    }}
                    src={productNum.imageUrl}
                  />
                ) : (
                  <img
                    style={{
                      width: "160px",
                      borderLeft: "1px solid #dddbdb",
                      margin: " 5% 0 5% 0",
                    }}
                    src={placeH}
                  />
                )}
                <p
                  style={{
                    width: "100%",
                    paddingRight: "5%",
                    display: "flex",
                    fontWeight: "bold",
                    color: "gray",
                    fontSize: "18px",
                    margin: "0",
                  }}
                >
                  {productNum.productName}
                </p>
              </div>

              {
                <>
                  <div
                    style={{
                      width: "90%",
                      display: "flex",
                      flexDirection: "row",
                      height: "7vh",
                      borderRadius: "50px",
                      backgroundColor: "#e5e5e5",
                      border: "none",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "center",
                      borderBottom: "1px solid #dddbdb",
                      margin: "5%",
                    }}
                  >
                    <input
                      type="number"
                      onChange={(e) => setadd(e.target.value)}
                      placeholder="مقدار"
                      style={{
                        backgroundColor: "#e5e5e5",
                        height: "100%",
                        width: "30%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        borderRadius: "0 50px 50px 0",
                        border: "none",
                        borderLeft: "1px solid rgb(209, 208, 208)",
                      }}
                    />
                    <p
                      style={{
                        width: "30%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        margin: "0",
                        fontWeight: "bold",
                      }}
                    >
                      {productNum.unitName}
                    </p>
                    {addpre === true ? (
                      <p
                        style={{
                          width: "30%",
                          backgroundColor: "#ff7014",
                          color: "#fff",
                          height: "100%",
                          borderRadius: "50px 0 0 50px",
                          margin: "0",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <Preloader2 />
                      </p>
                    ) : (
                      <p
                        onClick={() =>
                          handleAddKg(productNum.slug, productNum.productRef)
                        }
                        style={{
                          width: "30%",
                          backgroundColor: "#ff7014",
                          color: "#fff",
                          height: "100%",
                          borderRadius: "50px 0 0 50px",
                          margin: "0",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                      >
                        تایید
                      </p>
                    )}
                  </div>
                  {validModal === true && selectbutton === true ? (
                    <p
                      style={{
                        fontWeight: "bold",
                        color: "red",
                        width: "90%",
                        display: "flex",
                        marginRight: "5%",
                      }}
                    >
                      وارد کردن مقدار الزامیست!
                    </p>
                  ) : null}
                </>
              }
            </>
          )}
        </div>
      </Modal>

      {/* مودال برای وارد کردن مقدار در سبد خرید*/}
      <Modal style={{ marginTop: "180px" }} show={showmodalNumBasket}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {addpre === false && preCount === false ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                height: "5vh",
                justifyContent: "flex-start",
                alignItems: "center",
                textAlign: "center",
                borderBottom: "1px solid #dddbdb",
              }}
            >
              <img
                style={{
                  width: "20px",
                  marginRight: "5%",
                  cursor: "pointer",
                }}
                onClick={() => removeCross()}
                src={cross}
              />
            </div>
          ) : null}
          {/* این قسمت برای زمانی است که به کاربر یک مقدار انتخابی پیشنهاد میدهیم */}
          {iscorrect === true ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textAlign: "center",
                  borderBottom: "1px solid #dddbdb",
                }}
              >
                {productNumBasket.img !== "" ? (
                  <img
                    style={{
                      width: "120px",
                      borderLeft: "1px solid #dddbdb",
                      margin: " 5% 0 5% 0",
                    }}
                    src={productNumBasket.img}
                  />
                ) : (
                  <img
                    style={{
                      width: "160px",
                      borderLeft: "1px solid #dddbdb",
                      margin: " 5% 0 5% 0",
                    }}
                    // src={placeH}
                  />
                )}
                <p
                  style={{
                    width: "100%",
                    paddingRight: "5%",
                    display: "flex",
                    fontWeight: "bold",
                    color: "gray",
                    fontSize: "18px",
                    margin: "0",
                  }}
                >
                  {productNumBasket.name}
                </p>
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textAlign: "center",
                  borderBottom: "1px solid #dddbdb",
                }}
              >
                <p
                  style={{
                    width: "100%",
                    padding: "5%",
                    display: "flex",
                    fontWeight: "bold",
                    color: "#000",
                    fontSize: "15px",
                    margin: "0",
                    display: "flex",
                  }}
                >
                  {addRes.message}
                </p>
              </div>

              <div
                style={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  borderBottom: "1px solid #dddbdb",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  {addRes.selectOptions.map((i) =>
                    i.selectSelectOptions === true ? (
                      <button
                        className="btnModalAddToCart"
                        onClick={() => addBasket(i)}
                        style={{
                          width: "100%",
                          display: "flex",
                          margin: "5% 0 0 0",
                          borderRadius: "20px",
                          height: "5vh",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          border: "1px solid #ff7014",
                          fontWeight: "bold",
                          color: "#ff7014",
                        }}
                      >
                        {i.selectView}
                      </button>
                    ) : (
                      <button
                        className="btnModalAddToCart"
                        onClick={() => addBasket2(i)}
                        style={{
                          width: "100%",
                          display: "flex",
                          margin: "5% 0 0 0%",
                          borderRadius: "20px",
                          height: "5vh",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          border: "1px solid gray",
                          fontWeight: "bold",
                          color: "gray",
                        }}
                      >
                        {i.selectView}
                      </button>
                    ),
                  )}
                </div>
                {resOfSelect !== null &&
                Object.values(resOfSelect).length > 0 ? (
                  <button
                    onClick={() =>
                      clickAddModalkgBasket(
                        productNumBasket.slug,
                        resOfSelect.selectOptions,
                        productNumBasket.productId,
                      )
                    }
                    className="btnModalAdd"
                    style={{
                      width: "100%",
                      display: "flex",
                      margin: "5%",
                      borderRadius: "20px",
                      height: "5vh",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      border: "1px solid #ff7014",
                      fontWeight: "bold",
                      color: "#fff",
                      backgroundColor: "#ff7014",
                    }}
                  >
                    تایید
                  </button>
                ) : (
                  <button
                    style={{
                      width: "100%",
                      display: "flex",
                      margin: "5%",
                      borderRadius: "20px",
                      height: "5vh",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      border: "1px solid gray",
                      fontWeight: "bold",
                      color: "#fff",
                      backgroundColor: "gray",
                    }}
                  >
                    تایید
                  </button>
                )}
              </div>
            </div>
          ) : //  مرحله اول که کاربر میخواهد یک مقدار را وارد کند
          addpre === true || preCount === true ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                border: "none",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                gap: "20px",
              }}
            >
              <p
                style={{
                  alignItems: "flex-start",
                  height: "20vh",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  textAlign: "center",
                  margin: "0",
                  fontWeight: "bold",
                  color: "gray",
                  fontSize: "17px",
                }}
              >
                لطفا کمی صبر کنید...
              </p>
              <div
                style={{
                  height: "20vh",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  textAlign: "center",
                  margin: "0",
                  fontWeight: "bold",
                  color: "gray",
                  fontSize: "17px",
                }}
              >
                <Preloader3 />
              </div>
            </div>
          ) : (
            <>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textAlign: "center",
                  borderBottom: "1px solid #dddbdb",
                }}
              >
                {productNumBasket.img !== "" ? (
                  <img
                    onError={addDefaultSrc}
                    style={{
                      width: "160px",
                      borderLeft: "1px solid #dddbdb",
                      margin: " 5% 0 5% 0",
                    }}
                    src={productNumBasket.img}
                  />
                ) : (
                  <img
                    style={{
                      width: "160px",
                      borderLeft: "1px solid #dddbdb",
                      margin: " 5% 0 5% 0",
                    }}
                    src={placeH}
                  />
                )}
                <p
                  style={{
                    width: "100%",
                    paddingRight: "5%",
                    display: "flex",
                    fontWeight: "bold",
                    color: "gray",
                    fontSize: "18px",
                    margin: "0",
                  }}
                >
                  {productNumBasket.name}
                </p>
              </div>

              {
                <>
                  <div
                    style={{
                      width: "90%",
                      display: "flex",
                      flexDirection: "row",
                      height: "7vh",
                      borderRadius: "50px",
                      backgroundColor: "#e5e5e5",
                      border: "none",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "center",
                      borderBottom: "1px solid #dddbdb",
                      margin: "5%",
                    }}
                  >
                    <input
                      type="number"
                      onChange={(e) => setadd(e.target.value)}
                      placeholder="مقدار"
                      style={{
                        backgroundColor: "#e5e5e5",
                        height: "100%",
                        width: "30%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        borderRadius: "0 50px 50px 0",
                        border: "none",
                        borderLeft: "1px solid rgb(209, 208, 208)",
                      }}
                    />
                    <p
                      style={{
                        width: "30%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        margin: "0",
                        fontWeight: "bold",
                        fontSize: "13px",
                      }}
                    >
                      {productNumBasket.name}
                    </p>
                    {addpre === true ? (
                      <p
                        style={{
                          width: "30%",
                          backgroundColor: "#ff7014",
                          color: "#fff",
                          height: "100%",
                          borderRadius: "50px 0 0 50px",
                          margin: "0",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <Preloader2 />
                      </p>
                    ) : (
                      <p
                        onClick={() =>
                          handleAddKgBasket(
                            productNumBasket.productCode,
                            productNumBasket.productId,
                          )
                        }
                        style={{
                          width: "30%",
                          backgroundColor: "#ff7014",
                          color: "#fff",
                          height: "100%",
                          borderRadius: "50px 0 0 50px",
                          margin: "0",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                      >
                        تایید
                      </p>
                    )}
                  </div>
                  {validModal === true && selectbutton === true ? (
                    <p
                      style={{
                        fontWeight: "bold",
                        color: "red",
                        width: "90%",
                        display: "flex",
                        marginRight: "5%",
                      }}
                    >
                      وارد کردن مقدار الزامیست!
                    </p>
                  ) : null}
                </>
              }
            </>
          )}
        </div>
      </Modal>

      {ToastError === true && toast.length > 0 ? (
        <div className="divShowMssge">
          <p className="pShowMssge">{toast}</p>
        </div>
      ) : null}

      <Modal show={loc}>
        <div className="locDiv">
          <p className="locTest">{loctest}</p>
          <button className="locTestButton" onClick={() => setloc(false)}>
            بستن
          </button>
        </div>
      </Modal>
      {/* نمایش پیغام وب سرویس ها */}
      <Modal backdrop="static" onHide={() => setError(false)} show={Error}>
        <div className="myModalToast">
          <p className="myModalToastMssge">{ToastMsge}</p>
          <button onClick={() => setError(false)}>بستن</button>
        </div>
      </Modal>
    </div>
  );
};

export default App;
